// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

label {
  font-family: "Open Sans", sans-serif;
}

::ng-deep#page-wrapper {
  padding-bottom: 60px;
}

::ng-deep#wrapper {
  overflow-x: initial;
}

::ng-deep.implement-is .to-do {
  padding: 0px;
  border: 1px solid rgb(245, 67, 89);
  margin-bottom: 15px;
}
::ng-deep.implement-is .to-do p {
  display: initial;
}
::ng-deep.implement-is .to-do .col-sm-6 {
  padding: 0px;
  float: left;
}
::ng-deep.implement-is .to-do .col-sm-2 {
  padding: 0px;
  border-left: 1px dotted #ccc;
  float: left;
}
::ng-deep.implement-is .to-do .to-do-term {
  background-color: rgb(245, 67, 89);
  min-height: 30px;
}
::ng-deep.implement-is .next-input-tabs {
  width: 90%;
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 10px;
}
::ng-deep.implement-is .next-input-tabs input {
  height: 35px;
  padding: 10px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
::ng-deep.implement-is .next-input-tabs input:focus {
  border-color: rgb(0, 173, 208);
}
::ng-deep.implement-is .drag-content:hover {
  cursor: move;
}
::ng-deep.implement-is .implement-color {
  color: rgb(245, 67, 89);
}
::ng-deep.implement-is ::ng-deep #toast-container {
  margin-top: 40px;
}
::ng-deep.implement-is .input-tabs {
  min-height: 21px;
}
::ng-deep.implement-is .card-default h3 {
  cursor: pointer;
}
::ng-deep.implement-is .implement-section .to-do-term {
  padding-left: 10px;
  padding-right: 10px;
  color: #fff;
}
::ng-deep.implement-is .implement-section .ng-star-inserted label {
  min-width: 30px;
}
::ng-deep.implement-is .implement-section .ng-star-inserted input {
  width: 100%;
  margin-bottom: 0.5em;
  margin-top: 0;
}
::ng-deep.implement-is .implement-section .to-do .col-sm-2 input {
  width: 100%;
}
::ng-deep.implement-is .implement-section .col-sm-12.to-do > div:last-child.col-sm-3 .report-input {
  width: calc(100% - 56px);
  display: inline-block;
}
::ng-deep.implement-is .implement-section .col-sm-12.to-do > div:last-child.col-sm-3 input {
  width: 100%;
  margin-bottom: 0.5em;
}
::ng-deep.implement-is .implement-section .col-sm-12.to-do > div:last-child.col-sm-3 .fa {
  display: inline-block;
  width: auto;
  margin-left: 8px;
  border: none;
}
::ng-deep.implement-is .implement-inner {
  display: flex;
}
::ng-deep.implement-is .implement-inner .col-sm-5,
::ng-deep.implement-is .implement-inner .col-sm-3 {
  padding: 0;
}
::ng-deep.implement-is .implement-inner .col-sm-3 {
  border-left: 1px dotted #ccc;
}
::ng-deep.implement-is .implement-table {
  border: 1px solid #ccc;
  margin-bottom: 15px;
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}
::ng-deep.implement-is .ngx-datepicker-calendar-container {
  z-index: 999;
}
::ng-deep.implement-is .implement-table .heading-section {
  display: block;
  background-color: #e3e3e3;
  min-height: 30px;
  padding: 0 10px;
  color: #676a6c;
}
::ng-deep.implement-is .implement-table .heading-section--editbg {
  background-color: #F5F5F5;
  color: #676A6C;
}
::ng-deep.implement-is .implement-table td,
::ng-deep.implement-is .implement-table th {
  padding: 0 !important;
}
::ng-deep.implement-is .implement-table thead tr th,
::ng-deep.implement-is .implement-table tbody tr td {
  width: 15%;
  padding: 0 !important;
}
::ng-deep.implement-is .implement-table tbody tr td {
  vertical-align: top;
}
::ng-deep.implement-is .implement-table thead tr th:first-child,
::ng-deep.implement-is .implement-table tbody tr td:first-child {
  width: 40% !important;
}
::ng-deep.implement-is .implement-table thead tr th:last-child,
::ng-deep.implement-is .implement-table tbody tr td:last-child {
  width: 30% !important;
}
::ng-deep.implement-is .implement-table thead th:not(:last-child),
::ng-deep.implement-is .implement-table tbody td:not(:last-child) {
  border-right: 1px dotted #ccc;
}
::ng-deep.implement-is .implement-table tbody tr td input {
  width: 100%;
}
::ng-deep.implement-is .implement-table tbody tr td:first-child input {
  width: calc(100% - 35px);
}
::ng-deep.implement-is .implement-table tbody tr td:last-child input {
  width: calc(100% - 59px);
  margin-right: 10px;
}
::ng-deep.implement-is .implement-table th:not(:first-child) {
  text-align: left;
}
::ng-deep.implement-is .implement-table th h4 {
  color: #656565;
}
::ng-deep.implement-is app-implement-challenge-action-plan,
::ng-deep.implement-is app-implement-challenge-next24 {
  display: block;
  margin-top: 30px;
}
::ng-deep.implement-is .card-default .card-body {
  padding-top: 0;
  padding-bottom: 0;
}
::ng-deep.implement-is .card-default .list-columns {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
::ng-deep.implement-is .card-default .input-form label {
  min-width: 20px !important;
  margin-top: 10px;
}
::ng-deep.implement-is .card-show .input-form {
  padding-top: 15px;
  padding-bottom: 10px;
}
::ng-deep.implement-is ::ng-deep .card-default .alert {
  margin-bottom: 0 !important;
}
::ng-deep.implement-is .card-default .table.implement-table .list-columns {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
::ng-deep.implement-is .card-default .table.implement-table th h4,
::ng-deep.implement-is .card-default .table.implement-table td p,
::ng-deep.implement-is .card-default .table.implement-table td span {
  margin-bottom: 0 !important;
  padding: 12px !important;
}
::ng-deep.implement-is .implement-table__head td {
  background: #e3e3e3;
}
::ng-deep.implement-is .implement-table__head--editbg td {
  background: #F5F5F5;
  color: #676A6C;
}
::ng-deep.implement-is .tooltipicon {
  position: relative;
  display: inline-block;
  font-size: 18px;
}
::ng-deep.implement-is .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(245, 67, 89);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
  line-height: 1.2em;
  /* Position the tooltip */
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
@media screen and (max-width: 1199px) {
  ::ng-deep.implement-is .tooltipicon .tooltiptext {
    left: auto;
    right: 10px;
  }
}
::ng-deep.implement-is .tooltipicon:hover .tooltiptext {
  visibility: visible;
}
::ng-deep.implement-is .btn-develop {
  background-color: #66bd4a;
  color: #fff;
  padding: 0.375rem 1rem;
  border-radius: 3px;
}
::ng-deep.implement-is table.implement-table td > div,
::ng-deep.implement-is table.implement-table td > form {
  padding: 10px !important;
}
::ng-deep.implement-is .report-grid input {
  display: inline-block;
}
::ng-deep.implement-is .btn-bottom .btn-warning {
  margin-left: 10px;
}
::ng-deep.implement-is .generate-pdf {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}
@media screen and (max-width: 851px) {
  ::ng-deep.implement-is .generate-pdf {
    position: relative;
    top: 0;
    right: 0;
    margin-bottom: 20px;
  }
}
::ng-deep.implement-is .summary-pdf {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 170px;
}
@media screen and (max-width: 851px) {
  ::ng-deep.implement-is .summary-pdf {
    position: relative;
    top: 0;
    right: -7px;
    margin-bottom: 20px;
  }
}
::ng-deep.implement-is .mainnav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 30px 0 40px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .mainnav {
    margin: 10px 0 30px;
  }
}
::ng-deep.implement-is .mainnav.mainnav--bottom {
  margin: 30px 0 40px;
}
::ng-deep.implement-is .mainnav.mainnav--bottom ul li a {
  padding: 12px 30px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .mainnav.mainnav--bottom ul li a {
    padding: 10px 20px;
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .mainnav.mainnav--bottom ul li a {
    padding: 9px;
    font-size: 11px;
  }
}
::ng-deep.implement-is .mainnav.mainnav--bottom ul li.active a {
  background-color: #bbb !important;
  border-top: 1px solid #bbb !important;
  border-right: 1px solid #bbb !important;
  border-bottom: 1px solid #bbb !important;
}
::ng-deep.implement-is .mainnav--editmode {
  margin: 0 0 15px;
}
::ng-deep.implement-is .mainnav--editmode .mainnav__list {
  flex: 1;
  border-radius: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .mainnav--editmode .mainnav__list {
    flex: none;
    width: 100%;
  }
}
::ng-deep.implement-is .mainnav--editmode .mainnav__list li {
  width: 100%;
  flex: 1;
}
::ng-deep.implement-is .mainnav--editmode .mainnav__list li a {
  width: 100%;
  padding: 5px 2px;
  text-align: center;
}
::ng-deep.implement-is .mainnav__editmodeicon {
  margin-left: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .mainnav__editmodeicon {
    margin: 10px 0 0 auto;
  }
}
::ng-deep.implement-is .mainnav__editmodeicon ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  height: 100%;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li {
  list-style: none;
  transition: none;
  width: 37px;
  height: 100%;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #CFDBE2;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.active {
  background-color: #676a6c;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li:not(:last-child) {
  margin-right: 5px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .mainnav__editmodeicon ul li:not(:last-child) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .mainnav__editmodeicon ul li {
    width: 35px;
    height: 31px;
    display: none;
  }
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.mainnav__editmodepin {
  display: flex;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st0 {
  fill: #FFFFFF;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st1 {
  fill: #cfdbe2;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st0 {
  fill: #6d6e71;
}
::ng-deep.implement-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st1 {
  fill: #FFFFFF;
}
::ng-deep.implement-is .stick-challenge {
  position: relative;
}
::ng-deep.implement-is .stick-challenge .card__implementtable {
  min-height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9;
  position: relative;
}
::ng-deep.implement-is .stick-challenge .card__implementtable .card-body__subtitle {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
}
::ng-deep.implement-is .info {
  color: #fff;
  border: 1px solid rgb(245, 67, 89);
  margin-bottom: 18px;
  padding: 20px 40px;
  border-radius: 6px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .info {
    padding: 12px 20px;
  }
}
::ng-deep.implement-is .info.infotitle {
  background-color: rgb(245, 67, 89);
}
::ng-deep.implement-is .info.infotitle h3 {
  color: #fff;
}
::ng-deep.implement-is .info h1 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .info h1 {
    font-size: 28px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info h1 {
    font-size: 24px;
  }
}
::ng-deep.implement-is .info h1 .info__maintitle {
  margin-right: auto;
}
::ng-deep.implement-is .info h1 small {
  color: #fff;
  font-size: 80%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info h1 small {
    width: 100%;
    margin-top: 5px;
  }
}
::ng-deep.implement-is .info .card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
::ng-deep.implement-is .info .card__toprow--tne .card__topcol:first-child {
  width: 72% !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info .card__toprow--tne .card__topcol:first-child {
    flex: 1;
    width: auto !important;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol {
  padding: 0 15px;
  width: 33.3333333333%;
}
::ng-deep.implement-is .info .card__toprow .card__topcol:nth-child(1) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol:nth-child(1) {
    flex: 1;
    margin-right: auto;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol--tab {
  width: 44%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol--tab {
    width: 120px;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol--tt {
  width: 28%;
  margin-left: auto;
  text-align: right;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol--tt {
    width: auto;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol--tt svg {
  max-width: 16px;
  cursor: pointer;
}
::ng-deep.implement-is .info .card__toprow .card__topcol--tt .card__pinicon {
  position: absolute;
  right: -17px;
  top: -15px;
  width: 20px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol--tt .card__pinicon {
    right: 2px;
    top: 1px;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--title > div:first-child {
  margin-right: 15px;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
  line-height: 1;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:not(:first-child) {
  margin-left: -1px;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button {
  color: rgb(245, 67, 89);
  border: 1px solid rgb(245, 67, 89);
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount {
  color: rgb(245, 67, 89);
  background-color: #efefef;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid rgb(245, 67, 89);
  color: rgb(245, 67, 89);
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount {
  color: rgb(245, 67, 89);
  background-color: #efefef;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg .st0 {
  fill: rgb(245, 67, 89);
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: rgb(245, 67, 89);
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover {
  color: rgb(245, 67, 89);
  opacity: 1;
}
::ng-deep.implement-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover > span.card__topcount {
  color: rgb(245, 67, 89);
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.implement-is .info .card__toprow .card__h3button {
  border: 1px solid rgb(245, 67, 89);
  background-color: transparent;
  padding: 4px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(245, 67, 89);
  font-size: 22px;
  line-height: 1.2;
  transition: all ease 0.3s;
  cursor: pointer;
}
::ng-deep.implement-is .info .card__toprow .card__h3button:hover {
  background-color: rgb(245, 67, 89);
  color: #fff;
}
::ng-deep.implement-is .info .card__toprow .card__h3button:focus {
  outline: none;
}
::ng-deep.implement-is .info .card__toprow .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.implement-is .info .card__toprow .tooltipicon i {
  color: rgb(245, 67, 89);
}
::ng-deep.implement-is .info .card__toprow .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.implement-is .info .card__toprow .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(245, 67, 89);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.implement-is .info h3 {
  font-size: 20px;
  margin: 0;
  cursor: pointer;
  color: rgb(245, 67, 89);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .info h3 {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info h3 {
    font-size: 15px;
    word-break: break-word;
  }
}
::ng-deep.implement-is .info h3 > *:not(:last-child) {
  margin-right: 5px;
}
::ng-deep.implement-is .info h3 .card__bwnh3pencil a {
  color: rgb(245, 67, 89);
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info h3 .card__bwnh3button {
    width: 100%;
    margin-top: 10px;
  }
}
::ng-deep.implement-is .info h3 .card__bwnh3button button {
  font-size: 18px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .info h3 .card__bwnh3button button {
    font-size: 16px !important;
  }
}
::ng-deep.implement-is .info h3 i {
  cursor: pointer;
  font-size: 0.9em;
}
::ng-deep.implement-is .info h3 i + div {
  padding-left: 7px;
}
::ng-deep.implement-is .info h3 i + div span {
  display: block;
  font-size: 0.7em;
}
::ng-deep.implement-is .info h3 i + span {
  padding-left: 7px;
}
::ng-deep.implement-is .info h3 a {
  margin-left: 10px;
  color: rgb(245, 67, 89);
}
::ng-deep.implement-is .info h3.d-flex {
  display: flex;
}
::ng-deep.implement-is .info h3.d-flex div:first-child {
  padding-right: 10px;
}
::ng-deep.implement-is .info h3.d-flex div:nth-child(2) span {
  display: block;
}
::ng-deep.implement-is .info .tooltipicon {
  position: relative;
  display: inline-block;
}
::ng-deep.implement-is .info .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.implement-is .info .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(245, 67, 89);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 15px;
  line-height: 1.2em;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.implement-is .topheading {
  color: #fff;
  background-color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
  margin-bottom: 18px;
  padding: 24px;
  border-radius: 6px;
}
::ng-deep.implement-is .topheading h1 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
}
::ng-deep.implement-is .topheading h1 small {
  color: #fff;
  font-size: 80%;
}
::ng-deep.implement-is .card-default {
  border-radius: 6px;
  border-top-width: 3px;
  border: 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
::ng-deep.implement-is .card-default.card-default--summary {
  box-shadow: none;
}
::ng-deep.implement-is .card-default.card-default--summary .info {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.implement-is .card-default.card-default--summary .card-body {
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
  border-radius: 0;
}
::ng-deep.implement-is .card-default.card-default--summary .card-body__inner {
  padding: 15px 20px;
}
::ng-deep.implement-is .card-default.card-default--summary + div {
  margin-top: 20px;
}
::ng-deep.implement-is .card-default + div {
  margin-top: 30px;
}
::ng-deep.implement-is .card-default .info {
  margin: 0;
}
::ng-deep.implement-is .card-default .info.card__headactive {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.implement-is .card-default .info.card__headactive--cc {
  background-color: rgb(245, 67, 89);
}
::ng-deep.implement-is .card-default .info.card__headactive--cc .card__topcol h3 {
  color: #fff;
}
::ng-deep.implement-is .card-default .info.card__headactive--cc .card__topcol ul li button {
  border-color: #fff;
  background-color: #fff;
}
::ng-deep.implement-is .card-default .info.card__headactive--cc .card__topcol ul li button span {
  color: rgb(245, 67, 89);
  background-color: #fff;
}
::ng-deep.implement-is .card-default .info.card__headactive--cc .card__topcol ul li button .st0 {
  fill: #fff !important;
}
::ng-deep.implement-is .card-default .info.card__headactive--cc i {
  color: #fff;
}
::ng-deep.implement-is .card-default .info.card__headactive .card__topcol--tt svg {
  max-width: 16px;
  width: 100%;
}
::ng-deep.implement-is .card-default .info.card__headactive .card__topcol--tt .tooltipicon i {
  color: #ff485c;
}
::ng-deep.implement-is .card-default .info.card__headactive.challenge__sol {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
}
::ng-deep.implement-is .card-default .info.card__headactive.challenge__sol .card__topcol--tt span {
  position: absolute;
  right: 8px;
  top: 6px;
}
::ng-deep.implement-is .card-default .card-body__inner {
  padding: 15px 40px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .card-default .card-body__inner {
    padding: 12px 20px;
  }
}
::ng-deep.implement-is .card-default .card-body {
  display: none;
  border: 1px solid #CFDBE2;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
::ng-deep.implement-is .card-default .card-body--ov {
  overflow: visible;
}
::ng-deep.implement-is .card-default .card-body.card-show {
  display: block;
}
::ng-deep.implement-is .card-default .card-body.card-show__wbg {
  background-color: #fff;
}
::ng-deep.implement-is .card-default .card-body__finalstate p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body__finalstate p {
    font-size: 13px;
  }
}
::ng-deep.implement-is .card-default .card-body__finalstate p:last-child {
  margin-bottom: 0;
}
::ng-deep.implement-is .card-default .card-body__finalstate--2 {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
::ng-deep.implement-is .card-default .card-body__finalstate--2 > div {
  width: 50%;
  padding: 0 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body__finalstate--2 > div {
    width: 100%;
  }
}
::ng-deep.implement-is .card-default .card-body__finalstate--2 > div p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.implement-is .card-default .card-body__finalstate--2 > div p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.implement-is .card-default .card-body__subtitle {
  margin-bottom: 16px;
  padding-left: 0;
}
::ng-deep.implement-is .card-default .card-body__subtitle--pl0 {
  padding-left: 0;
}
::ng-deep.implement-is .card-default .card-body__subtitle *:last-child {
  margin-bottom: 0;
}
::ng-deep.implement-is .card-default .card-body__subtitle p {
  color: #969798;
  font-size: 15px;
}
::ng-deep.implement-is .card-default .card-body__subtitle p i {
  padding-left: 5px;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown {
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li {
  list-style: none;
  position: relative;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li + li {
  margin-left: 15px;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li > a {
  font-size: 16px;
  color: #676a6a;
  font-weight: 700;
  background-color: #fff;
  border: 1px solid #ededed;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  transition: all ease 0.3s;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body__pdfdropdown > li > a {
    font-size: 13px;
  }
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li > a .page-heading__icon {
  padding: 11px 14px;
  border-right: 1px solid #ededed;
  display: flex;
  align-items: center;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li > a .page-heading__text {
  padding: 11px 14px;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li > a:hover {
  border: 1px solid #CFDBE2;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li:hover > ul {
  display: block;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li ul {
  margin: 0;
  padding: 0;
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  width: 144px;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
  background-color: #fff;
  z-index: 99;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li ul li {
  list-style: none;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li ul li + li {
  border-top: 1px solid #dcdcdc;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li ul li a {
  color: #696969;
  text-align: center;
  padding: 8px 20px;
  font-size: 13px;
  display: block;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body__pdfdropdown > li ul li a:hover {
  background-color: #f9f9f9;
}
::ng-deep.implement-is .card-default .c-radio label {
  padding-left: 0;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.implement-is .card-default .c-radio label > i {
  position: relative;
  top: 2px;
  margin-right: 6px;
  opacity: 0.6;
}
::ng-deep.implement-is .card-default .c-radio label > span {
  vertical-align: middle;
}
::ng-deep.implement-is .card-default .c-radio input {
  opacity: 0;
  margin: 0;
  display: none;
}
::ng-deep.implement-is .card-default .c-radio input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.implement-is .card-default .c-radio input + span::before {
  position: absolute;
  color: rgb(245, 67, 89);
  opacity: 0;
  font-size: 11px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.implement-is .card-default .c-radio input:checked + span {
  border-color: rgb(245, 67, 89);
}
::ng-deep.implement-is .card-default .c-radio input:checked + span::before {
  opacity: 1;
}
::ng-deep.implement-is .card-default .checkbox {
  margin-top: 0;
}
::ng-deep.implement-is .card-default .checkbox label {
  min-height: 20px;
  padding-left: 0;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.implement-is .card-default .checkbox label > i {
  position: relative;
  top: 1px;
  margin-right: 6px;
}
::ng-deep.implement-is .card-default .checkbox label > span {
  vertical-align: middle;
}
::ng-deep.implement-is .card-default .checkbox input {
  opacity: 0;
  position: absolute;
  display: none;
}
::ng-deep.implement-is .card-default .checkbox input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.implement-is .card-default .checkbox input + span::before {
  font-size: 12px;
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.implement-is .card-default .checkbox input:checked + span {
  border-color: #5D9CEC;
  background-color: #5D9CEC;
}
::ng-deep.implement-is .card-default .checkbox input:checked + span::before {
  opacity: 1;
}
::ng-deep.implement-is .card-default .card-body__button {
  background-color: #f5f5f5;
  border-top: 1px solid #e3e3e3;
  padding: 12px 40px;
}
::ng-deep.implement-is .card-default .card-body__button .card-button {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn + .btn {
  margin-left: 15px;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .float-right {
  margin-left: auto;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-implement {
  background-color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
  color: #fff;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-implement:hover {
  background-color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-danger {
  background-color: #fff;
  border-color: #fff;
  color: #ef6272;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-danger:hover {
  background-color: #ED2D2D;
  border-color: #EC2121;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-warning em {
  margin: 0;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall:hover {
  background-color: #fff;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall:hover em {
  margin-right: 6px;
}
::ng-deep.implement-is .card-default .card-body__button .card-button .btn-deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body--ebtn {
  margin-top: 15px;
  padding: 15px 40px;
  border-top: 1px solid #CFDBE2;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn {
    padding: 12px 20px;
  }
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow {
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
  padding: 0 8px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
    width: 100%;
    text-align: center;
  }
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow > div + div {
    margin-top: 10px;
  }
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow > div.card-body--col--last {
  margin-left: auto;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  padding: 7px 16px;
  text-align: center;
  transition: all ease 0.3s;
  font-weight: 900;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
    font-size: 12px;
  }
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn i,
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--save {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--clarify {
  background-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--implement {
  background-color: rgb(245, 67, 89);
  color: #fff;
  border-color: rgb(245, 67, 89);
  font-weight: 900;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel {
  padding: 0;
  background-color: transparent;
  margin-left: 0;
  border: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #676a6c;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel:hover {
  color: #000;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--converge {
  padding: 0 8px;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
  font-size: 14px;
  color: #676a6c;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
  background-color: #f5f5f5;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
    padding-right: 7px;
    padding-left: 7px;
  }
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover em {
  margin-right: 6px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    background-color: #f5f5f5;
    color: #ed5562;
    padding-right: 16px;
    padding-left: 16px;
  }
}
@media only screen and (max-width: 767px) and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    padding-right: 7px;
    padding-left: 7px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall > span {
    position: relative;
    left: 0;
  }
  ::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
    margin-right: 6px !important;
  }
}
::ng-deep.implement-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .note-3 {
  padding: 15px 15px 10px;
  border: 2px solid rgb(0, 173, 208);
  margin-bottom: 15px;
}
::ng-deep.implement-is .card-default .note-3 label {
  color: rgb(0, 173, 208);
}
::ng-deep.implement-is .card-default .footer-line {
  color: rgb(0, 173, 208);
}
::ng-deep.implement-is .card-default p {
  font-size: 15px;
}
::ng-deep.implement-is .card-default p:last-child {
  margin-bottom: 0;
}
::ng-deep.implement-is .card-default .card-body__edit {
  position: relative;
  overflow: hidden;
}
::ng-deep.implement-is .card-default .card-body__edit--ov {
  overflow: visible;
}
::ng-deep.implement-is .card-default .card-body__edit .breakthrough-input-tabs,
::ng-deep.implement-is .card-default .card-body__edit .datadump-input-tabs {
  width: 100%;
  margin-right: 0;
  position: relative;
}
::ng-deep.implement-is .card-default .card-body__edit .breakthrough-input-tabs input,
::ng-deep.implement-is .card-default .card-body__edit .breakthrough-input-tabs select,
::ng-deep.implement-is .card-default .card-body__edit .datadump-input-tabs input,
::ng-deep.implement-is .card-default .card-body__edit .datadump-input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #ccc !important;
  border-radius: 4px;
  font-size: 15px;
}
::ng-deep.implement-is .card-default .card-body__edit .breakthrough-input-tabs input:focus,
::ng-deep.implement-is .card-default .card-body__edit .breakthrough-input-tabs select:focus,
::ng-deep.implement-is .card-default .card-body__edit .datadump-input-tabs input:focus,
::ng-deep.implement-is .card-default .card-body__edit .datadump-input-tabs select:focus {
  outline: none !important;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow > div {
  padding: 0 15px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol--mb0 {
  margin-bottom: 0;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol--2 {
  width: 50%;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow > div > div {
  position: relative;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow select {
  appearance: none;
  background-image: url("https://assets.foursightonline.com/app/images/select.png");
  background-size: 10px;
  background-position: right 10px center;
  background-repeat: no-repeat;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow textarea {
  width: 100%;
  border: 1px solid #ccc;
  resize: none;
  border-radius: 3px;
  padding: 10px 15px;
  font-size: 15px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel {
  width: 35px;
  padding-right: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber {
  width: 40px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-right: 0;
  border-radius: 4px 0 0 4px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput {
  width: calc(100% - 41px);
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label {
  margin-bottom: 0;
  font-weight: 900;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
  width: 315px;
  padding-right: 15px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
  width: calc(100% - 351px);
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input.add-line,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input.add-line {
  padding-right: 70px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput.card-body__editinput--np input,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput.card-body__editinput--np input {
  padding-right: 15px;
}
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child,
::ng-deep.implement-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child {
  width: 100%;
}
::ng-deep.implement-is .card-default .card-body__edit + .card-body__addnew button {
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .card-body__edit + .card-body__addnew button:hover {
  background-color: rgb(245, 67, 89);
  border: 1px solid rgb(245, 67, 89);
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}
::ng-deep.implement-is .card-default .breakthrough-input-tabs {
  width: 90%;
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.implement-is .card-default .breakthrough-input-tabs input {
  height: 35px;
  padding: 10px 15px;
  border: 1px solid rgb(245, 67, 89);
  border-radius: 4px;
  margin-bottom: 0;
}
::ng-deep.implement-is .card-default .input-tabs {
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 0 0 0 0;
  margin: 0;
}
::ng-deep.implement-is .card-default .input-tabs + i {
  position: relative;
  top: -1px;
}
::ng-deep.implement-is .card-default .input-tabs.card__body--cs {
  position: relative;
  border-bottom: 1px solid #e4e4e4;
}
::ng-deep.implement-is .card-default .input-tabs.card__body--cs::before, ::ng-deep.implement-is .card-default .input-tabs.card__body--cs::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: 100%;
  width: 40px;
  height: 1px;
  background-color: #e4e4e4;
}
::ng-deep.implement-is .card-default .input-tabs.card__body--cs::after {
  right: auto;
  left: 100%;
}
::ng-deep.implement-is .card-default .input-tabs .select_faded {
  opacity: 0.2;
  padding-left: 32px;
}
::ng-deep.implement-is .card-default .input-tabs input,
::ng-deep.implement-is .card-default .input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  margin: 7px 0px;
}
::ng-deep.implement-is .card-default .input-tabs label {
  width: 20px;
  margin: 0;
}
::ng-deep.implement-is .card-default .input-tabs select {
  width: 9%;
}
::ng-deep.implement-is .card-default .input-tabs input {
  width: 90%;
  margin-left: 15px;
}
::ng-deep.implement-is .card-default .input-group-text {
  cursor: pointer;
  padding: 3px 16px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.528571429;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #E9ECEF;
  border: 1px solid #DDE6E9;
  border-radius: 0.25rem;
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-default .input-group-text:hover {
  background-color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
  color: #fff;
}
::ng-deep.implement-is .card-default .input-group-text i {
  font-size: 12px;
}
::ng-deep.implement-is .card-default .list-columns {
  display: flex;
  flex-wrap: wrap;
  counter-reset: section;
}
::ng-deep.implement-is .card-default .list-columns.list-columns--2 > div {
  width: 100%;
}
::ng-deep.implement-is .card-default .list-columns .brainstorm-tabs {
  position: relative;
  padding-left: 23px;
}
::ng-deep.implement-is .card-default .list-columns .brainstorm-tabs::before {
  counter-increment: section;
  content: counter(section) ".";
  position: absolute;
  top: 0;
  left: 0;
}
::ng-deep.implement-is .idea-shop-list {
  padding: 20px;
  margin-left: 17px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .idea-shop-list li {
  width: 50%;
  margin-bottom: 10px;
}
::ng-deep.implement-is .brainstorm__col {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 17px;
}
::ng-deep.implement-is .brainstorm__col .brainstorm-main {
  width: calc(100% - 68px);
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.implement-is .brainstorm__col .brainstorm-main .brainstorm-group {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend {
  margin-right: -1px;
  width: 45px;
}
::ng-deep.implement-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend .input-group-text {
  background: transparent;
  border-color: rgb(245, 67, 89);
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep.implement-is .brainstorm__col .brainstorm-main .brainstorm-group input {
  width: calc(100% - 45px);
  height: 35px;
  border: 1px solid rgb(255, 121, 0);
  border-radius: 0 0.25rem 0.25rem 0;
}
::ng-deep.implement-is .point-evaluation {
  padding: 0px;
  border: 1.5px solid #66bd4a;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.implement-is .point-evaluation > div {
  padding: 10px;
}
::ng-deep.implement-is .point-evaluation .pluses {
  border-right: 1.5px solid #66bd4a;
  border-bottom: 1.5px solid #66bd4a;
}
::ng-deep.implement-is .point-evaluation .pluses h4::before {
  content: "P";
}
::ng-deep.implement-is .point-evaluation .opportunities {
  border-bottom: 1.5px solid #66bd4a;
}
::ng-deep.implement-is .point-evaluation .opportunities h4::before {
  content: "O";
}
::ng-deep.implement-is .point-evaluation .issues {
  border-right: 1.5px solid #66bd4a;
}
::ng-deep.implement-is .point-evaluation .issues h4::before {
  content: "I";
}
::ng-deep.implement-is .point-evaluation .new-thinking h4::before {
  content: "Nt";
}
::ng-deep.implement-is .point-evaluation h4 {
  position: relative;
  padding-left: 50px;
  color: #66bd4a;
  font-size: 16px;
  margin: 0 0 10px;
}
::ng-deep.implement-is .point-evaluation h4::before {
  content: "";
  background: #66bd4a;
  color: #fff;
  font-size: 20px;
  height: 35px;
  width: 35px;
  position: absolute;
  border-radius: 50%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
::ng-deep.implement-is .point-evaluation h4 small {
  display: block;
  margin-top: 4px;
  color: inherit;
  line-height: 1.3;
  font-size: 82%;
}
::ng-deep.implement-is .point-evaluation p {
  color: #66bd4a;
}
::ng-deep.implement-is .point-evaluation span.fill-bottom {
  width: 100%;
}
::ng-deep.implement-is .point-evaluation .icons-right i {
  font-size: 21px;
  color: #66bd4a;
  cursor: pointer;
}
::ng-deep.implement-is .point-evaluation .icons-right i:not(:last-child) {
  margin-right: 10px;
}
::ng-deep.implement-is .point-evaluation .fill-input {
  width: calc(100% - 35px);
  display: inline-block;
  margin-right: 15px;
}
::ng-deep.implement-is .point-evaluation .fill-input label {
  display: inline-block;
  min-width: 20px;
  color: #66bd4a;
}
::ng-deep.implement-is .point-evaluation .fill-input input {
  display: inline-block;
  width: calc(100% - 20px);
  height: 34px;
  border-radius: 3px;
  margin: 1px 0;
}
::ng-deep.implement-is .point-evaluation .input-tabs .input-tabs__row {
  width: calc(100% - 35px);
  display: inline-block;
  margin-right: 15px;
  position: relative;
  vertical-align: middle;
}
::ng-deep.implement-is .point-evaluation .input-tabs .input-tabs__row .pr-0 {
  padding-right: 0;
}
::ng-deep.implement-is .point-evaluation .input-tabs .input-tabs__row > i {
  position: absolute;
  top: 50%;
  right: -26px;
  transform: translateY(-50%);
}
::ng-deep.implement-is .point-evaluation .input-tabs label {
  display: inline-block;
  min-width: 20px;
  color: #66bd4a;
}
::ng-deep.implement-is .point-evaluation .input-tabs input,
::ng-deep.implement-is .point-evaluation .input-tabs select {
  height: 34px;
  border-radius: 3px;
  margin: 1px 0;
}
::ng-deep.implement-is .point-evaluation .input-tabs select {
  display: inline-block;
  width: calc(100% - 20px);
}
::ng-deep.implement-is .develop-footer-note {
  color: #66bd4a;
}
::ng-deep.implement-is .d-flex.count-div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.implement-is .d-flex.count-div label {
  width: 35px;
}
::ng-deep.implement-is .implement-section .input-tabs {
  display: block !important;
}
::ng-deep.implement-is .card-bottom-button .button {
  font-size: 13px;
  color: #fff;
  padding: 8px 10px;
  border-radius: 3px;
  transition: all ease 0.3s;
}
::ng-deep.implement-is .card-bottom-button .button:hover {
  opacity: 0.8;
}
::ng-deep.implement-is .card-bottom-button .button i {
  font-size: 0.8em;
}
::ng-deep.implement-is .card-bottom-button .button.btn-clarify {
  background-color: rgb(0, 173, 208);
}
::ng-deep.implement-is .card-bottom-button .button.btn-ideate {
  background-color: rgb(255, 121, 0);
}
::ng-deep.implement-is .card-bottom-button .button.btn-implement {
  background-color: rgb(245, 67, 89);
}
::ng-deep.implement-is .cancelTool.tooltipicon {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
::ng-deep.implement-is .cancelTool.tooltipicon .tooltiptext {
  width: 150px;
  color: #676a6c;
  text-align: center;
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
  top: -25px;
  left: 10px;
}
::ng-deep.implement-is .cancelTool.tooltipicon:hover .tooltiptext {
  visibility: visible;
}
::ng-deep.implement-is .card_solution b {
  font-size: 15px;
}
::ng-deep.implement-is .card_solution .solution-list {
  margin-bottom: 0;
  width: 100%;
  margin-top: 10px;
}
::ng-deep.implement-is .card_solution .solution-list span {
  display: block;
}
::ng-deep.implement-is .card_solution .solution-list__selection1 {
  margin-top: 10px;
}
::ng-deep.implement-is .card_solution .solution-list__selection2 {
  margin-left: 20px;
}

::ng-deep.cdk-overlay-container {
  position: absolute !important;
  top: 288px !important;
}

.tooltippopup {
  max-width: 360px;
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  right: -400px;
  padding: 45px 24px 24px;
  text-align: left;
  z-index: 9999;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  transition: all ease 0.3s;
  overflow-y: auto;
}
.tooltippopup--active {
  right: 0;
}
.tooltippopup__btn {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 0 10px;
}
.tooltippopup__btn li {
  list-style: none;
  text-align: center;
  cursor: pointer;
  width: 33.3333333333%;
}
.tooltippopup__btn li button {
  width: 100%;
  color: rgb(245, 67, 89);
  font-size: 12px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  border: 1px solid rgb(245, 67, 89);
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
.tooltippopup__btn li button:focus {
  outline: none;
}
.tooltippopup__btn li button.tooltippopup__btncompleted {
  opacity: 0.2;
}
.tooltippopup__btn li button.tooltippopup__btncompleted:hover {
  opacity: 1;
}
.tooltippopup__btn li button.tooltippopup__btnactive {
  opacity: 1;
}
.tooltippopup__btn li button:hover {
  position: relative;
  z-index: 9;
}
.tooltippopup__btn li + li {
  margin-left: -1px;
}
.tooltippopup__btn li:first-child button {
  border-radius: 3px 0 0 3px;
}
.tooltippopup__btn li:last-child button {
  border-radius: 0 3px 3px 0;
}
.tooltippopup h4 {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 1.2;
}
.tooltippopup p {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.4;
}
.tooltippopup__close {
  position: absolute;
  top: 10px;
  right: 25px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: all ease 0.3s;
}
.tooltippopup__close:hover {
  transform: rotate(360deg);
}
.tooltippopup__close > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.tooltippopup__close > div span {
  position: absolute;
  background: #676a6c;
}
.tooltippopup__close > div span:nth-child(1) {
  top: 0;
  left: calc(50% - 1px);
  width: 2px;
  height: 100%;
}
.tooltippopup__close > div span:nth-child(2) {
  top: calc(50% - 1px);
  left: 0;
  width: 100%;
  height: 2px;
}
.tooltippopup__child {
  margin-top: 20px;
}
.tooltippopup__childdata .table-responsive {
  overflow-x: auto;
  margin-bottom: 10px;
}
.tooltippopup__childdata .table-responsive table {
  min-width: 297px;
  border: 1px solid #e7eaec;
}
.tooltippopup__childdata .table-responsive table th,
.tooltippopup__childdata .table-responsive table td {
  border: 1px solid #e7eaec;
  min-width: 120px;
}
.tooltippopup__childdata .table-responsive + * {
  margin-top: 20px;
}
.tooltippopup__childdata--clarify h4 {
  color: rgb(0, 173, 208);
}
.tooltippopup__childdata--ideate h4 {
  color: rgb(255, 121, 0);
}
.tooltippopup__childdata--develop h4 {
  color: rgb(105, 190, 40);
}
.tooltippopup__childdata--implement h4 {
  color: rgb(245, 67, 89);
}
.tooltippopup__childdata h4 {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 2px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.tooltippopup__childdata h4 + h5 {
  mask-type: 10px;
}
.tooltippopup__childdata p {
  margin-bottom: 5px;
  line-height: 1.3;
}
.tooltippopup__childdata p:last-child {
  margin-bottom: 0;
}
.tooltippopup__childdata + div {
  margin-top: 17px;
}
.tooltippopup__links {
  padding: 0;
  margin: 0;
}
.tooltippopup__links li {
  list-style: none;
  width: 100%;
}
.tooltippopup__links li a {
  position: relative;
  color: rgb(245, 67, 89);
  transition: all ease 0.3s;
}
.tooltippopup__links li a:hover {
  opacity: 0.75;
}
.tooltippopup__links li + li {
  margin-top: 4px;
}

.popaccordian__rowhead {
  position: relative;
  cursor: pointer;
  border: 1px solid rgb(245, 67, 89);
  padding: 9px;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}
.popaccordian__rowheadarrow {
  position: absolute;
  top: 0;
  left: 0;
}
.popaccordian__rowhead h5 {
  margin: 0;
  position: relative;
  color: rgb(245, 67, 89);
  padding-left: 10px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowhead h5 i {
  transition: all ease 0.3s;
}
.popaccordian__rowbody {
  border: 1px solid rgb(245, 67, 89);
  border-top: 0;
  display: none;
  border-radius: 0 0 3px 3px;
}
.popaccordian__rowbodyinner {
  padding: 10px;
}
.popaccordian__rowbodyinner > *:last-child {
  margin-bottom: 0;
}
.popaccordian__rowbodyinner h5 {
  margin: 0 0 10px;
  position: relative;
  color: rgb(245, 67, 89);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowbodyinner ul {
  margin: 0;
  padding: 0;
}
.popaccordian__rowbodyinner ul li {
  list-style: none;
  font-size: 14px;
  line-height: 1.3;
  position: relative;
  padding-left: 10px;
}
.popaccordian__rowbodyinner ul li::before {
  content: "";
  position: absolute;
  top: 7px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
.popaccordian__rowbodyinner ul li + li {
  margin-top: 5px;
}
.popaccordian__row + div {
  margin-top: 15px;
}
.popaccordian__row--active .popaccordian__rowhead {
  border-radius: 3px 3px 0 0;
}
.popaccordian__row--active .popaccordian__rowhead i {
  transform: rotate(90deg);
}
.popaccordian__row:first-child .popaccordian__rowbody {
  display: block;
}

.prevnext {
  padding: 10px 0;
}
.prevnext__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  margin: 0;
}
.prevnext li {
  list-style: none;
}
.prevnext li.prevnext__next {
  margin-left: auto;
}
.prevnext li.prevnext__action {
  margin-left: auto;
}
.prevnext li.prevnext__action a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 14px;
  color: #676a6c;
  cursor: pointer;
  opacity: 0.6;
  transition: all ease 0.3s;
}
.prevnext li.prevnext__action a:hover {
  opacity: 1;
}
.prevnext li.prevnext__prev a:hover > i {
  left: -5px;
}
.prevnext li.prevnext__next a {
  background-color: rgb(245, 67, 89);
  color: #fff;
  opacity: 1;
  padding: 6px 12px;
  border-radius: 3px;
}
.prevnext li.prevnext__next a:hover > i {
  left: 3px;
}
.prevnext li a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 14px;
  color: #676a6c;
  opacity: 0.47;
  padding: 6px 0;
  display: inline-block;
  transition: all ease 0.3s;
}
.prevnext li a i {
  position: relative;
  font-size: 1.1em;
  left: 0;
  transition: all ease 0.3s;
}

::ng-deep.card__implementtable {
  overflow-y: auto;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.card__implementtable table {
    width: 700px;
    max-width: none;
  }
}
::ng-deep.card__implementtable .card-body__addnew button {
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  margin: 6px 50px;
  color: #676a6c;
  transition: all ease 0.3s;
}
::ng-deep.card__implementtable .card-body__addnew button:hover {
  background-color: rgb(245, 67, 89);
  border: 1px solid rgb(245, 67, 89);
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}

.playbtn {
  position: absolute;
  right: 9px;
  bottom: 7px;
  color: #06a6ce;
}

.Del-data-btn {
  padding: 40px 0;
}
.Del-data-btn .btn {
  margin-left: 15px;
  background-color: #fff;
  border-color: #f5f5f5;
  color: #ff485c;
}
.Del-data-btn .cancelbtn {
  color: #676a6c;
  text-align: center;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
}

.editmode {
  margin-bottom: 30px;
}
.editmode--not {
  margin-bottom: 0;
}
.editmode__listrow {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow {
    grid-template-columns: 1fr;
  }
}
.editmode__listrow--equalblocks {
  display: flex;
  flex-wrap: wrap;
}
.editmode__listrow--equalblocks > .editmode__listcol {
  flex: 1;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow--equalblocks > .editmode__listcol {
    flex: none;
    width: 100%;
  }
}
.editmode__listrow--fullblocks {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid1 {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid3 > div:nth-child(1) {
  grid-row: 1/3;
}
.editmode__listrow--grid4 > div:nth-child(1) {
  grid-row: 1/4;
}
.editmode__listrow--grid5 > div:nth-child(1) {
  grid-row: 1/5;
}
.editmode__listrow--grid6 > div:nth-child(1) {
  grid-row: 1/6;
}
.editmode__listrow--grid7 > div:nth-child(1) {
  grid-row: 1/7;
}
.editmode__listcell {
  padding: 10px 15px;
  background-color: #EBEBEB;
  border: 1px solid #CFDBE2;
  border-radius: 6px;
  height: 100%;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell {
    font-size: 13px;
  }
}
.editmode__listcell h3 {
  color: #676A6C;
  margin-bottom: 5px;
}
.editmode__listcell h3 a,
.editmode__listcell h3 i {
  color: inherit;
}
.editmode__listcell p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell p {
    font-size: 13px;
  }
}
.editmode__listcell p:last-child {
  margin-bottom: 0;
}

.trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}

.row--editmodebg {
  background-color: #fff;
  padding: 40px 35px;
}
.row--wbg {
  background-color: #fff;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.row--editmodebg {
  background-color: #fff;
  padding: 40px 35px;
}

.trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
.trackInfo--inputclr {
  color: rgb(245, 67, 89);
  font-size: 11px;
  background: transparent;
  margin-left: 8px;
  padding-left: 0;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
::ng-deep .datepicker-container input {
  padding: 8px 10px;
  font-size: 14px;
  width: 200px;
  outline: 0;
  border: 1px solid #dfe3e9;
}

.card-body__minus--hide {
  display: none;
}

.pdf-modal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/implement-challenge/implement-challenge.component.scss","webpack://./src/app/components/challenges/_cn-shared.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;ACvUA;EACI,oCAAA;AD0UJ;;AAjZA;EACI,oBAAA;AAoZJ;;AAjZA;EACI,mBAAA;AAoZJ;;AAhZI;EACI,YAAA;EACA,kCAAA;EACA,mBAAA;AAmZR;AAjZQ;EACI,gBAAA;AAmZZ;AA/YI;EACI,YAAA;EACA,WAAA;AAiZR;AA9YI;EACI,YAAA;EACA,4BAAA;EACA,WAAA;AAgZR;AA7YI;EACI,kCDRU;ECSV,gBAAA;AA+YR;AA5YI;EACI,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AA8YR;AA5YQ;EACI,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AA8YZ;AA5YY;EACI,8BD5BA;AC0ahB;AAzYI;EACI,YAAA;AA2YR;AAxYI;EACI,uBDnCU;AC6alB;AAvYI;EACI,gBAAA;AAyYR;AAtYI;EACI,gBAAA;AAwYR;AArYI;EACI,eAAA;AAuYR;AApYI;EACI,kBAAA;EACA,mBAAA;EACA,WAAA;AAsYR;AAnYI;EACI,eAAA;AAqYR;AAlYI;EACI,WAAA;EACA,oBAAA;EACA,aAAA;AAoYR;AAjYI;EACI,WAAA;AAmYR;AAhYI;EACI,wBAAA;EACA,qBAAA;AAkYR;AA/XI;EACI,WAAA;EACA,oBAAA;AAiYR;AA9XI;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAgYR;AA7XI;EAGI,aAAA;AA+XR;AA5XI;;EAEI,UAAA;AA8XR;AA3XI;EACI,4BAAA;AA6XR;AA1XI;EACI,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;AA4XR;AAzXI;EACI,YAAA;AA2XR;AAxXI;EACI,cAAA;EACA,yBD7GW;EC8GX,gBAAA;EACA,eAAA;EACA,cD5Ga;ACserB;AAvXI;EACI,yBAAA;EACA,cAAA;AAyXR;AAtXI;;EAEI,qBAAA;AAwXR;AArXI;;EAEI,UAAA;EACA,qBAAA;AAuXR;AApXI;EACI,mBAAA;AAsXR;AAnXI;;EAEI,qBAAA;AAqXR;AAlXI;;EAEI,qBAAA;AAoXR;AAjXI;;EAEI,6BAAA;AAmXR;AAhXI;EACI,WAAA;AAkXR;AA/WI;EACI,wBAAA;AAiXR;AA9WI;EACI,wBAAA;EACA,kBAAA;AAgXR;AA7WI;EACI,gBAAA;AA+WR;AA5WI;EACI,cAAA;AA8WR;AA3WI;;EAEI,cAAA;EACA,gBAAA;AA6WR;AAzWQ;EACI,cAAA;EACA,iBAAA;AA2WZ;AAxWQ;EACI,4BAAA;EACA,+BAAA;AA0WZ;AAtWY;EACI,0BAAA;EACA,gBAAA;AAwWhB;AAnWI;EACI,iBAAA;EACA,oBAAA;AAqWR;AAlWI;EACI,2BAAA;AAoWR;AAjWI;EACI,yBAAA;EACA,4BAAA;AAmWR;AAhWI;;;EAGI,2BAAA;EACA,wBAAA;AAkWR;AA/VI;EACI,mBD1NW;AC2jBnB;AA9VI;EACI,mBAAA;EACA,cAAA;AAgWR;AA7VI;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;AA+VR;AA5VI;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBDnPU;ECoPV,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AA8VR;AA5VQ;EAlBJ;IAmBQ,UAAA;IACA,WAAA;EA+VV;AACF;AA5VI;EACI,mBAAA;AA8VR;AA3VI;EACI,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AA6VR;AA1VI;;EAEI,wBAAA;AA4VR;AAxVQ;EACI,qBAAA;AA0VZ;AAtVI;EACI,iBAAA;AAwVR;AArVI;EACI,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAuVR;AArVQ;EANJ;IAOQ,kBAAA;IACA,MAAA;IACA,QAAA;IACA,mBAAA;EAwVV;AACF;AArVI;EACI,eAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;AAuVR;AArVQ;EANJ;IAOQ,kBAAA;IACA,MAAA;IACA,WAAA;IACA,mBAAA;EAwVV;AACF;AApVI;ECnUA,aAAA;EAEA,eAAA;EAMA,uBAAA;ED8TI,mBAAA;AA4VR;AA1VQ;EALJ;IAMQ,mBAAA;EA6VV;AACF;AA3VQ;EACI,mBAAA;AA6VZ;AAzVoB;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AA2VxB;AAzVwB;EANJ;IAOQ,kBAAA;IACA,eAAA;EA4V1B;AACF;AA1VwB;EAXJ;IAYQ,YAAA;IACA,eAAA;EA6V1B;AACF;AAzVwB;EACI,iCAAA;EACA,qCAAA;EACA,uCAAA;EACA,wCAAA;AA2V5B;AApVQ;EACI,gBAAA;AAsVZ;AApVY;EACI,OAAA;EACA,kBAAA;AAsVhB;AApVgB;EAJJ;IAKQ,UAAA;IACA,WAAA;EAuVlB;AACF;AArVgB;EACI,WAAA;EACA,OAAA;AAuVpB;AArVoB;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;AAuVxB;AAjVQ;EACI,gBAAA;AAmVZ;AAjVY;EAHJ;IAIQ,qBAAA;EAoVd;AACF;AAlVY;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AAoVhB;AAlVgB;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAoVpB;AAjVoB;EACI,yBAAA;AAmVxB;AAhVoB;EACI,iBAAA;AAkVxB;AAhVwB;EAHJ;IAIQ,eAAA;EAmV1B;AACF;AAhVoB;EA1BJ;IA2BQ,WAAA;IACA,YAAA;IACA,aAAA;EAmVtB;AACF;AAjVoB;EACI,aAAA;AAmVxB;AAhV4B;EACI,aAAA;AAkVhC;AA/U4B;EACI,aAAA;AAiVhC;AA3UgC;EACI,aAAA;AA6UpC;AA1UgC;EACI,aAAA;AA4UpC;AAjUI;EACI,kBAAA;AAmUR;AAjUQ;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAmUZ;AAjUY;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AAmUhB;AA7TI;EACI,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AA+TR;AA7TQ;EAPJ;IAQQ,kBAAA;EAgUV;AACF;AA9TQ;EACI,kCD/eM;AC+yBlB;AA9TY;EACI,WAAA;AAgUhB;AA5TQ;EACI,eAAA;EACA,gBAAA;EACA,SAAA;ECpdR,mCAAA;EACA,8BAAA;EDqdQ,aAAA;EACA,eAAA;EACA,mBAAA;AA+TZ;AA7TY;EATJ;IAUQ,eAAA;EAgUd;AACF;AA9TY;EAbJ;IAcQ,eAAA;EAiUd;AACF;AA/TY;EACI,kBAAA;AAiUhB;AA7TY;EACI,WAAA;EACA,cAAA;AA+ThB;AA7TgB;EAJJ;IAKQ,WAAA;IACA,eAAA;EAgUlB;AACF;AA5TQ;EC5hBJ,aAAA;EAEA,eAAA;EAYA,mBAAA;EDihBQ,eAAA;AAoUZ;AA9ToB;EACI,qBAAA;AAgUxB;AA9TwB;EAHJ;IAIQ,OAAA;IACA,sBAAA;EAiU1B;AACF;AA5TY;EACI,eAAA;EACA,qBAAA;AA8ThB;AA5TgB;EACI,UAAA;AA8TpB;AA5ToB;EAHJ;IAIQ,OAAA;IACA,kBAAA;EA+TtB;AACF;AA5TgB;EACI,UAAA;AA8TpB;AA5ToB;EAHJ;IAIQ,YAAA;EA+TtB;AACF;AA5TgB;EACI,UAAA;EACA,iBAAA;EACA,iBAAA;AA8TpB;AA5ToB;EALJ;IAMQ,WAAA;EA+TtB;AACF;AA7ToB;EACI,eAAA;EACA,eAAA;AA+TxB;AA5ToB;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AA8TxB;AA5TwB;EANJ;IAOQ,UAAA;IACA,QAAA;EA+T1B;AACF;AA3TgB;EChmBZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADu5BJ;AAjUoB;EACI,kBAAA;AAmUxB;AA/TgB;ECzmBZ,aAAA;EAEA,eAAA;EAMA,uBAAA;AD06BJ;AArUoB;EC7mBhB,aAAA;EAEA,eAAA;ED6mBoB,SAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AA2UxB;AAtUoC;EACI,uBAAA;AAwUxC;AApUwC;EADJ;IAEQ,WAAA;EAuU1C;AACF;AAhUoC;EACI,sBAAA;AAkUxC;AA9TwC;EADJ;IAEQ,YAAA;EAiU1C;AACF;AA5T4B;EACI,iBAAA;AA8ThC;AA1TgC;EACI,kBAAA;AA4TpC;AAvTgC;EACI,uBDxpBlB;ECypBkB,kCAAA;AAyTpC;AAvToC;EACI,uBD5pBtB;EC6pBsB,yBAAA;AAyTxC;AAvTwC;EACI,yBAAA;EACA,WAAA;AAyT5C;AAlTgC;EACI,YAAA;EACA,kCAAA;EACA,uBD3qBlB;AC+9BlB;AAlToC;EACI,uBD9qBtB;EC+qBsB,yBAAA;AAoTxC;AAlTwC;EACI,yBAAA;EACA,WAAA;AAoT5C;AA9S4B;EACI,kBAAA;EACA,wBD5rBhB;EC6rBgB,eAAA;EACA,iBAAA;ECxpB5B,mCAAA;EACA,8BAAA;EDypB4B,qBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;ECnrB5B,yBAAA;EDurB4B,gBAAA;AAmThC;AAjTgC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AAmTpC;AAjToC;EACI,sBD9sBtB;ACigClB;AA/SgC;EAzBJ;IA0BQ,gBAAA;IACA,eAAA;EAkTlC;AACF;AAhTgC;EACI,aAAA;EACA,gBAAA;AAkTpC;AA9SoC;EADJ;IAEQ,aAAA;EAiTtC;AACF;AA9SgC;EACI,aAAA;AAgTpC;AA9SoC;EAHJ;IAIQ,qBAAA;EAiTtC;AACF;AA9SgC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCDjvBlB;ECkvBkB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AAgTpC;AA9SoC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EAiTtC;AACF;AA9SgC;EACI,uBDnwBlB;ECowBkB,UAAA;AAgTpC;AA7SgC;EACI,uBDxwBlB;ECywBkB,yBAAA;EACA,UAAA;AA+SpC;AAvSY;EACI,kCAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;ECjvBZ,mCAAA;EACA,8BAAA;EDkvBY,uBDxxBE;ECyxBF,eAAA;EACA,gBAAA;EC3wBZ,yBAAA;ED6wBY,eAAA;AA4ShB;AA1SgB;EACI,kCD/xBF;ECgyBE,WAAA;AA4SpB;AAzSgB;EACI,aAAA;AA2SpB;AAvSY;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAyShB;AAvSgB;EACI,uBD/yBF;ACwlClB;AAtSgB;EACI,mBAAA;AAwSpB;AArSgB;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBD1zBF;EC2zBE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAuSpB;AAlSQ;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,uBD90BM;EEqCd,mCAAA;EACA,8BAAA;EA3CA,aAAA;EAEA,eAAA;EAYA,mBAAA;ADmnCJ;AAzSY;EATJ;IAUQ,eAAA;EA4Sd;AACF;AA1SY;EAbJ;IAcQ,eAAA;IACA,sBAAA;EA6Sd;AACF;AA3SY;EACI,iBAAA;AA6ShB;AAxSgB;EACI,uBDn2BF;AC6oClB;AApSgB;EAFJ;IAGQ,WAAA;IACA,gBAAA;EAuSlB;AACF;AArSgB;EACI,0BAAA;EACA,8BAAA;EACA,6BAAA;AAuSpB;AArSoB;EALJ;IAMQ,0BAAA;EAwStB;AACF;AApSY;EACI,eAAA;EACA,gBAAA;AAsShB;AApSgB;EACI,iBAAA;AAsSpB;AApSoB;EACI,cAAA;EACA,gBAAA;AAsSxB;AAlSgB;EACI,iBAAA;AAoSpB;AAhSY;EACI,iBAAA;EACA,uBD74BE;AC+qClB;AA/RY;EAGI,aAAA;AAiShB;AA/RgB;EACI,mBAAA;AAiSpB;AA7RoB;EACI,cAAA;AA+RxB;AAzRQ;EACI,kBAAA;EACA,qBAAA;AA2RZ;AAzRY;EACI,mBAAA;AA2RhB;AAxRY;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBD76BE;EC86BF,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AA0RhB;AArRI;EACI,WAAA;EACA,kCD97BU;EC+7BV,8BD/7BU;ECg8BV,mBAAA;EACA,aAAA;EACA,kBAAA;AAuRR;AArRQ;EACI,eAAA;EACA,gBAAA;EACA,SAAA;AAuRZ;AArRY;EACI,WAAA;EACA,cAAA;AAuRhB;AAlRI;EAsGI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,yCAAA;AA+KR;AAvRQ;EACI,gBAAA;AAyRZ;AAvRY;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAyRhB;AAtRY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAwRhB;AAtRgB;EACI,kBAAA;AAwRpB;AApRY;EACI,gBAAA;AAsRhB;AAlRQ;EACI,gBAAA;AAoRZ;AAjRQ;EACI,SAAA;AAmRZ;AAjRY;EACI,6BAAA;EACA,4BAAA;AAmRhB;AAjRgB;EACI,kCDx/BF;AC2wClB;AAhRwB;EACI,WAAA;AAkR5B;AA5QgC;EACI,kBAAA;EACA,sBAAA;AA8QpC;AA5QoC;EACI,uBDvgCtB;ECwgCsB,sBAAA;AA8QxC;AA3QoC;EACI,qBAAA;AA6QxC;AAtQoB;EACI,WAAA;AAwQxB;AAnQoB;EACI,eAAA;EACA,WAAA;AAqQxB;AAjQwB;EACI,cAAA;AAmQ5B;AA9PgB;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;AAgQpB;AA7PwB;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AA+P5B;AAnPQ;EACI,kBAAA;AAqPZ;AAnPY;EAHJ;IAIQ,kBAAA;EAsPd;AACF;AAlPQ;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AAoPZ;AAlPY;EACI,iBAAA;AAoPhB;AAjPY;EACI,cAAA;AAmPhB;AAjPgB;EACI,sBAAA;AAmPpB;AA7OgB;EACI,eAAA;EACA,gBAAA;AA+OpB;AA7OoB;EAJJ;IAKQ,eAAA;EAgPtB;AACF;AA9OoB;EACI,gBAAA;AAgPxB;AA5OgB;EC3mCZ,aAAA;EAEA,eAAA;ED2mCgB,eAAA;AAkPpB;AAhPoB;EACI,UAAA;EACA,eAAA;AAkPxB;AAhPwB;EAJJ;IAKQ,WAAA;EAmP1B;AACF;AAjPwB;EACI,kBAAA;EACA,kBAAA;AAmP5B;AAjP4B;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AAmPhC;AA5OY;EACI,mBAAA;EACA,eAAA;AA8OhB;AA5OgB;EACI,eAAA;AA8OpB;AA3OgB;EACI,gBAAA;AA6OpB;AA1OgB;EACI,cAAA;EACA,eAAA;AA4OpB;AA1OoB;EACI,iBAAA;AA4OxB;AAvOY;EACI,UAAA;EACA,SAAA;EAGA,aAAA;EAEA,eAAA;AAyOhB;AAvOgB;EACI,gBAAA;EACA,kBAAA;AAyOpB;AAvOoB;EACI,iBAAA;AAyOxB;AAtOoB;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EAGA,aAAA;EAEA,eAAA;EAGA,yBAAA;AAwOxB;AAtOwB;EAjBJ;IAkBQ,eAAA;EAyO1B;AACF;AAvOwB;EACI,kBAAA;EACA,+BAAA;EAGA,aAAA;EAGA,mBAAA;AAyO5B;AAtOwB;EACI,kBAAA;AAwO5B;AArOwB;EACI,yBAAA;AAuO5B;AAnOoB;EACI,cAAA;AAqOxB;AAlOoB;EACI,SAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AAoOxB;AAlOwB;EACI,gBAAA;AAoO5B;AAlO4B;EACI,6BAAA;AAoOhC;AAjO4B;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EAGA,yBAAA;AAmOhC;AAjOgC;EACI,yBAAA;AAmOpC;AAzNY;EACI,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA2NhB;AAzNgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AA2NpB;AAxNgB;EACI,sBAAA;AA0NpB;AAtNY;EACI,UAAA;EACA,SAAA;EACA,aAAA;AAwNhB;AAtNgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAwNpB;AAtNoB;EACI,kBAAA;EACA,uBDxyCN;ECyyCM,UAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AAwNxB;AAnNoB;EACI,8BDrzCN;AC0gDlB;AAlNoB;EACI,UAAA;AAoNxB;AA9MQ;EACI,aAAA;AAgNZ;AA9MY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAgNhB;AA9MgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;AAgNpB;AA7MgB;EACI,sBAAA;AA+MpB;AA3MY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AA6MhB;AA3MgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AA6MpB;AA3MoB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AA6MxB;AAxMoB;EACI,qBAAA;EACA,yBAAA;AA0MxB;AAvMoB;EACI,UAAA;AAyMxB;AAnMQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;AAqMZ;AAnMY;EACI,SAAA;EC94CZ,aAAA;EAEA,eAAA;EAYA,mBAAA;AD6kDJ;AAzMgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ECl4ChB,yBAAA;ADglDJ;AA3MoB;EACI,iBAAA;AA6MxB;AA1MoB;EACI,iBAAA;EACA,gBAAA;AA4MxB;AAxMgB;EACI,iBAAA;AA0MpB;AAvMgB;EACI,kCDn6CF;ECo6CE,8BDp6CF;ECq6CE,WAAA;AAyMpB;AAvMoB;EACI,kCDx6CN;ECy6CM,8BDz6CN;ACknDlB;AArMgB;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;AAuMpB;AArMoB;EACI,yBAAA;EACA,qBAAA;AAuMxB;AAlMoB;EACI,SAAA;AAoMxB;AAhMgB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ECt7ChB,yBAAA;AD2nDJ;AAlMoB;EACI,kBAAA;EACA,UAAA;EC37CpB,yBAAA;ADkoDJ;AAnMoB;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAqMxB;AAnMwB;EACI,kBAAA;EACA,OAAA;AAqM5B;AAlMwB;EACI,iBAAA;AAoM5B;AAhMoB;EACI,cAAA;EACA,eAAA;ECj9CpB,yBAAA;ADspDJ;AA9LQ;EACI,gBAAA;EACA,kBAAA;EACA,6BAAA;AAgMZ;AA7LY;EANJ;IAOQ,kBAAA;EAgMd;AACF;AA9LY;EACI,cAAA;ECv/CZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADirDJ;AApMgB;EACI,cAAA;AAsMpB;AApMoB;EAHJ;IAIQ,WAAA;IACA,kBAAA;EAuMtB;EArMsB;IACI,gBAAA;EAuM1B;AACF;AAnMwB;EACI,iBAAA;AAqM5B;AAhMgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAkMpB;AAhMoB;EATJ;IAUQ,eAAA;EAmMtB;AACF;AAjMoB;;EAEI,iBAAA;EACA,gBAAA;AAmMxB;AAhMoB;EACI,mCD9hDR;EC+hDQ,WAAA;AAkMxB;AA/LoB;EACI,kCDriDR;ECsiDQ,WAAA;AAiMxB;AA9LoB;EACI,kCDviDN;ECwiDM,WAAA;EACA,8BDziDN;EC0iDM,gBAAA;AAgMxB;AA7LoB;EACI,yBAAA;EACA,WAAA;AA+LxB;AA5LoB;EACI,UAAA;EACA,6BAAA;EACA,cAAA;EACA,SAAA;EACA,wED/kDX;ECglDW,eAAA;EACA,gBAAA;EACA,cD/iDH;AC6uDrB;AA5LwB;EACI,WAAA;AA8L5B;AA1LoB;EACI,yBAAA;EACA,WAAA;AA4LxB;AAzLoB;EACI,cAAA;AA2LxB;AAxLoB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EClkDpB,yBAAA;AD+vDJ;AA1LwB;EACI,eAAA;EACA,cD3kDP;ACuwDrB;AAzLwB;EACI,kBAAA;EACA,UAAA;EC5kDxB,yBAAA;AD0wDJ;AA1LwB;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AA4L5B;AA1L4B;EANJ;IAOQ,kBAAA;IACA,iBAAA;EA6L9B;AACF;AA3L4B;EACI,kBAAA;EACA,OAAA;AA6LhC;AA1L4B;EACI,iBAAA;AA4LhC;AAxLwB;EA1CJ;IA2CQ,yBAAA;IACA,cAAA;IACA,mBAAA;IACA,kBAAA;EA2L1B;AACF;AA1L4B;EAhDR;IAiDY,kBAAA;IACA,iBAAA;EA6L9B;AACF;AAtMwB;EAWI;IACI,kBAAA;IACA,OAAA;EA8L9B;EA3L0B;IACI,4BAAA;EA6L9B;AACF;AA1LwB;EACI,cAAA;EACA,eAAA;EC5nDxB,yBAAA;AD2zDJ;AAtLQ;EACI,uBAAA;EACA,kCAAA;EACA,mBAAA;AAwLZ;AAtLY;EACI,uBD7pDA;ACq1DhB;AApLQ;EACI,uBDlqDI;ACw1DhB;AAnLQ;EACI,eAAA;AAqLZ;AAnLY;EACI,gBAAA;AAqLhB;AAjLQ;EACI,kBAAA;EACA,gBAAA;AAmLZ;AAjLY;EACI,iBAAA;AAmLhB;AAhLY;;EAEI,WAAA;EACA,eAAA;EACA,kBAAA;AAkLhB;AAhLgB;;;;EAEI,YAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AAoLpB;AAlLoB;;;;EACI,wBAAA;AAuLxB;AAlLY;EACI,eAAA;EC5sDZ,aAAA;EAEA,eAAA;ADm4DJ;AAtLgB;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AAwLpB;AAtLoB;EACI,gBAAA;AAwLxB;AArLoB;EACI,UAAA;AAuLxB;AApLoB;EACI,kBAAA;AAsLxB;AAlLgB;EAGI,gBAAA;EACA,iFAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;AAoLpB;AAjLgB;EACI,WAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAmLpB;AAhLgB;;ECpvDZ,aAAA;EAEA,eAAA;AD06DJ;AApLoB;;EACI,WAAA;EACA,mBAAA;EC1vDpB,aAAA;EAEA,eAAA;EAYA,mBAAA;AD26DJ;AA1LoB;;EACI,WAAA;EACA,kBAAA;ECjwDpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EANA,uBAAA;ED6vDoB,eAAA;EACA,0BAAA;AAqMxB;AAnMwB;;EACI,wBAAA;AAsM5B;AAnMwB;;EACI,gBAAA;EACA,gBAAA;AAsM5B;AAlMoB;;EACI,YAAA;EACA,mBAAA;AAqMxB;AAlMoB;;EACI,yBAAA;AAqMxB;AAnMwB;;EAEI,mBAAA;AAqM5B;AAjM4B;;EACI,mBAAA;AAoMhC;AA/LoB;;EACI,WAAA;AAkMxB;AA3LgB;EACI,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EChyDhB,yBAAA;ADg+DJ;AA7LoB;EACI,kCDnzDN;ECozDM,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA+LxB;AAzLQ;EACI,UAAA;EACA,qBAAA;EACA,kBAAA;AA2LZ;AAzLY;EACI,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;AA2LhB;AAvLQ;EAQI,oBAAA;EC10DR,mBAAA;ED40DQ,WAAA;EACA,gBAAA;EACA,SAAA;AAsLZ;AAjMY;EACI,kBAAA;EACA,SAAA;AAmMhB;AAvLY;EACI,kBAAA;EACA,gCAAA;AAyLhB;AAvLgB;EAEI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AAwLpB;AArLgB;EACI,WAAA;EACA,UAAA;AAuLpB;AAnLY;EACI,YAAA;EACA,kBAAA;AAqLhB;AAlLY;;EAEI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAoLhB;AAjLY;EACI,WAAA;EACA,SAAA;AAmLhB;AAhLY;EACI,SAAA;AAkLhB;AA/KY;EACI,UAAA;EACA,iBAAA;AAiLhB;AA7KQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EAGA,2BAAA;EC/4DR,yBAAA;ADikEJ;AA/KY;EACI,kCDl6DE;ECm6DF,8BDn6DE;ECo6DF,WAAA;AAiLhB;AA9KY;EACI,eAAA;AAgLhB;AA5KQ;EAGI,aAAA;EAEA,eAAA;EACA,sBAAA;AA8KZ;AA3KgB;EACI,WAAA;AA6KpB;AAzKY;EACI,kBAAA;EACA,kBAAA;AA2KhB;AAzKgB;EACI,0BAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AA2KpB;AArKI;EACI,aAAA;EACA,iBAAA;EAGA,aAAA;EAEA,eAAA;AAuKR;AArKQ;EACI,UAAA;EACA,mBAAA;AAuKZ;AAnKI;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;EACA,mBAAA;AAqKR;AAnKQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AAqKZ;AAnKY;EACI,WAAA;EACA,kBAAA;EAGA,aAAA;EAEA,eAAA;AAqKhB;AAnKgB;EACI,kBAAA;EACA,WAAA;AAqKpB;AAnKoB;EACI,uBAAA;EACA,8BDv/DN;ECw/DM,YAAA;EACA,UAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AAqKxB;AAjKgB;EACI,wBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCAAA;AAmKpB;AA7JI;EACI,YAAA;EACA,2BAAA;EACA,mBAAA;EAGA,aAAA;EAEA,eAAA;AA+JR;AA7JQ;EACI,aAAA;AA+JZ;AA5JQ;EACI,iCAAA;EACA,kCAAA;AA8JZ;AA5JY;EACI,YAAA;AA8JhB;AA1JQ;EACI,kCAAA;AA4JZ;AA1JY;EACI,YAAA;AA4JhB;AAxJQ;EACI,iCAAA;AA0JZ;AAxJY;EACI,YAAA;AA0JhB;AArJY;EACI,aAAA;AAuJhB;AAnJQ;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAqJZ;AAnJY;EACI,WAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EAGA,aAAA;EAGA,uBAAA;EAGA,mBAAA;AAqJhB;AAlJY;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAoJhB;AAhJQ;EACI,cAAA;AAkJZ;AA/IQ;EACI,WAAA;AAiJZ;AA7IY;EACI,eAAA;EACA,cAAA;EACA,eAAA;AA+IhB;AA7IgB;EACI,kBAAA;AA+IpB;AA1IQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AA4IZ;AA1IY;EACI,qBAAA;EACA,eAAA;EACA,cAAA;AA4IhB;AAzIY;EACI,qBAAA;EACA,wBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AA2IhB;AAtIY;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAwIhB;AAtIgB;EACI,gBAAA;AAwIpB;AArIgB;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EAGA,2BAAA;AAuIpB;AAnIY;EACI,qBAAA;EACA,eAAA;EACA,cAAA;AAqIhB;AAlIY;;EAEI,YAAA;EACA,kBAAA;EACA,aAAA;AAoIhB;AAjIY;EACI,qBAAA;EACA,wBAAA;AAmIhB;AA9HI;EACI,cAAA;AAgIR;AA7HI;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;AA+HR;AA7HQ;EACI,WAAA;AA+HZ;AA3HI;EACI,yBAAA;AA6HR;AAzHQ;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EAGA,yBAAA;AA2HZ;AAzHY;EACI,YAAA;AA2HhB;AAxHY;EACI,gBAAA;AA0HhB;AAvHY;EACI,kCDluEA;AC21EhB;AAtHY;EACI,kCDruED;AC61Ef;AArHY;EACI,kCDvuEE;AC81ElB;AAlHI;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;AAoHR;AAlHQ;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AAoHZ;AAhHY;EACI,mBAAA;AAkHhB;AA5GQ;EACI,eAAA;AA8GZ;AA3GQ;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;AA6GZ;AA3GY;EACI,cAAA;AA6GhB;AA1GY;EACI,gBAAA;AA4GhB;AAzGY;EACI,iBAAA;AA2GhB;;AArGA;EACI,6BAAA;EACA,qBAAA;AAwGJ;;AArGA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,wCAAA;EC9xEA,yBAAA;EDgyEA,gBAAA;AA0GJ;AAxGI;EACI,QAAA;AA0GR;AAvGI;EC1zEA,aAAA;EAEA,eAAA;ED0zEI,UAAA;EACA,gBAAA;AA6GR;AA3GQ;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AA6GZ;AA3GY;EACI,WAAA;EACA,uBDl0EE;ECm0EF,eAAA;EACA,iBAAA;EC/xEZ,mCAAA;EACA,8BAAA;EDgyEY,qBAAA;EACA,YAAA;EACA,SAAA;EACA,kCAAA;EACA,6BAAA;EACA,yBAAA;EChzEZ,gBAAA;ADi6EJ;AA9GgB;EACI,aAAA;AAgHpB;AA7GgB;EACI,YAAA;AA+GpB;AA7GoB;EACI,UAAA;AA+GxB;AA3GgB;EACI,UAAA;AA6GpB;AA1GgB;EACI,kBAAA;EACA,UAAA;AA4GpB;AAxGY;EACI,iBAAA;AA0GhB;AAtGgB;EACI,0BAAA;AAwGpB;AAnGgB;EACI,0BAAA;AAqGpB;AA/FI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAiGR;AA9FI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAgGR;AA7FI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EC33EJ,yBAAA;AD69EJ;AA/FQ;EAGI,yBAAA;AAiGZ;AA9FQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAGA,wBAAA;AAgGZ;AA9FY;EACI,kBAAA;EACA,mBAAA;AAgGhB;AA9FgB;EACI,MAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AAgGpB;AA7FgB;EACI,oBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AA+FpB;AAzFI;EACI,gBAAA;AA2FR;AAxFY;EACI,gBAAA;EACA,mBAAA;AA0FhB;AAxFgB;EACI,gBAAA;EACA,yBAAA;AA0FpB;AAxFoB;;EAEI,yBAAA;EACA,gBAAA;AA0FxB;AAtFgB;EACI,gBAAA;AAwFpB;AAnFgB;EACI,uBD/8EJ;ACoiFhB;AAhFgB;EACI,uBDp9EL;ACsiFf;AA7EgB;EACI,wBDz9EJ;ACwiFhB;AA1EgB;EACI,uBD99EF;AC0iFlB;AAxEY;EACI,eAAA;EACA,gBAAA;EACA,eAAA;ECh8EZ,mCAAA;EACA,8BAAA;AD2gFJ;AAzEgB;EACI,eAAA;AA2EpB;AAvEY;EACI,kBAAA;EACA,gBAAA;AAyEhB;AAvEgB;EACI,gBAAA;AAyEpB;AArEY;EACI,gBAAA;AAuEhB;AAlEI;EACI,UAAA;EACA,SAAA;AAoER;AAlEQ;EACI,gBAAA;EACA,WAAA;AAoEZ;AAlEY;EACI,kBAAA;EACA,uBDtgFE;EEed,yBAAA;AD8jFJ;AAlEgB;EACI,aAAA;AAoEpB;AAhEY;EACI,eAAA;AAkEhB;;AAvDQ;EACI,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;EACA,kBAAA;ECtiFR,aAAA;EAEA,eAAA;ADmmFJ;AA5DY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AA8DhB;AA3DY;EACI,SAAA;EACA,kBAAA;EACA,uBD7iFE;EC8iFF,kBAAA;ECzgFZ,mCAAA;EACA,8BAAA;ADukFJ;AA5DgB;ECliFZ,yBAAA;ADmmFJ;AA3DQ;EACI,kCAAA;EACA,aAAA;EACA,aAAA;EACA,0BAAA;AA6DZ;AA3DY;EACI,aAAA;AA6DhB;AA3DgB;EACI,gBAAA;AA6DpB;AA1DgB;EACI,gBAAA;EACA,kBAAA;EACA,uBDvkFF;EEqCd,mCAAA;EACA,8BAAA;AD+lFJ;AA1DgB;EACI,SAAA;EACA,UAAA;AA4DpB;AA1DoB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA4DxB;AA1DwB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AA4D5B;AAzDwB;EACI,eAAA;AA2D5B;AAnDQ;EACI,gBAAA;AAqDZ;AAjDY;EACI,0BAAA;AAmDhB;AAjDgB;ECjlFZ,wBAAA;ADuoFJ;AA/CY;EACI,cAAA;AAiDhB;;AAxCA;EACI,eAAA;AA2CJ;AAzCI;EC3oFA,aAAA;EAEA,eAAA;EAYA,mBAAA;EDgoFI,UAAA;EACA,SAAA;AAiDR;AA9CI;EACI,gBAAA;AAgDR;AA9CQ;EACI,iBAAA;AAgDZ;AA7CQ;EACI,iBAAA;AA+CZ;AA7CY;EClnFR,mCAAA;EACA,8BAAA;EDmnFY,eAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EC7oFZ,yBAAA;ADgsFJ;AAhDgB;EACI,UAAA;AAkDpB;AA5CY;EACI,UAAA;AA8ChB;AA1CQ;EACI,kCD5qFM;EC6qFN,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AA4CZ;AA1CY;EACI,SAAA;AA4ChB;AAxCQ;EClpFJ,mCAAA;EACA,8BAAA;EDmpFQ,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EC9qFR,yBAAA;AD4tFJ;AA3CY;EACI,kBAAA;EACA,gBAAA;EACA,OAAA;ECprFZ,yBAAA;ADouFJ;;AAxCA;EACI,gBAAA;AA2CJ;AAvCQ;EAFJ;IAGQ,YAAA;IACA,eAAA;EA0CV;AACF;AAtCQ;EACI,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cDptFS;EEIjB,yBAAA;AD2vFJ;AAxCY;EACI,kCDnuFE;ECouFF,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA0ChB;;AAnCA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AAsCJ;;AAnCA;EACI,eAAA;AAsCJ;AApCI;EACI,iBAAA;EAEA,sBAAA;EACA,qBAAA;EACA,cAAA;AAqCR;AAlCI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AAoCR;;AA9BA;EACI,mBAAA;AAiCJ;AA/BI;EACI,gBAAA;AAiCR;AA3BQ;EACI,aAAA;EACA,qCAAA;EACA,cAAA;AA6BZ;AA3BY;EALJ;IAMQ,0BAAA;EA8Bd;AACF;AA5BY;EACI,aAAA;EACA,eAAA;AA8BhB;AA5BgB;EACI,OAAA;AA8BpB;AA5BoB;EAHJ;IAIQ,UAAA;IACA,WAAA;EA+BtB;AACF;AA1BY;EACI,0BAAA;AA4BhB;AAxBgB;EACI,0BAAA;AA0BpB;AArBoB;EACI,aAAA;AAuBxB;AAjBoB;EACI,aAAA;AAmBxB;AAboB;EACI,aAAA;AAexB;AAToB;EACI,aAAA;AAWxB;AALoB;EACI,aAAA;AAOxB;AADQ;EACI,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAGZ;AAAY;EARJ;IASQ,eAAA;EAGd;AACF;AADY;EACI,cAAA;EACA,kBAAA;AAGhB;AADgB;;EAEI,cAAA;AAGpB;AACY;EACI,eAAA;EACA,gBAAA;AAChB;AACgB;EAJJ;IAKQ,eAAA;EAElB;AACF;AAAgB;EACI,gBAAA;AAEpB;;AAMA;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AAHJ;;AAQI;EACI,sBAAA;EACA,kBAAA;AALR;AAQI;EACI,sBAAA;AANR;;AAUA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAPJ;;AAUA;EACI,sBAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AAPJ;AASI;EACI,uBDh8FU;ECi8FV,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAPR;;AAWA;EACI,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AARJ;;AAWA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AARJ;;AAYA;EACI,mCAAA;EACA,UAAA;AATJ;;AAYA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AATJ;;AAYA;EACI,mCAAA;EACA,mBAAA;EACA,UAAA;AATJ;;AAYA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AATJ;;AAYA;EACI;IACI,UAAA;EATN;EAYE;IACI,UAAA;EAVN;EAaE;IACI,UAAA;EAXN;AACF;AAiBI;EACI,iBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AAfR;;AAqBI;EACI,aAAA;AAlBR;;AAsBA;EACI,aAAA;AAnBJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../cn-shared';\n\n::ng-deep#page-wrapper {\n    padding-bottom: 60px;\n}\n\n::ng-deep#wrapper {\n    overflow-x: initial;\n}\n\n::ng-deep.implement-is {\n    .to-do {\n        padding: 0px;\n        border: 1px solid $implement-color;\n        margin-bottom: 15px;\n\n        p {\n            display: initial;\n        }\n    }\n\n    .to-do .col-sm-6 {\n        padding: 0px;\n        float: left;\n    }\n\n    .to-do .col-sm-2 {\n        padding: 0px;\n        border-left: 1px dotted $color-neutral-mid;\n        float: left;\n    }\n\n    .to-do .to-do-term {\n        background-color: $implement-color;\n        min-height: 30px;\n    }\n\n    .next-input-tabs {\n        width: 90%;\n        display: inline-block;\n        margin-right: 20px;\n        margin-bottom: 10px;\n\n        input {\n            height: 35px;\n            padding: 10px 15px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n\n            &:focus {\n                border-color: $clarify-color;\n            }\n        }\n    }\n\n    .drag-content:hover {\n        cursor: move;\n    }\n\n    .implement-color {\n        color: $implement-color;\n    }\n\n    ::ng-deep #toast-container {\n        margin-top: 40px;\n    }\n\n    .input-tabs {\n        min-height: 21px;\n    }\n\n    .card-default h3 {\n        cursor: pointer;\n    }\n\n    .implement-section .to-do-term {\n        padding-left: 10px;\n        padding-right: 10px;\n        color: #fff;\n    }\n\n    .implement-section .ng-star-inserted label {\n        min-width: 30px;\n    }\n\n    .implement-section .ng-star-inserted input {\n        width: 100%;\n        margin-bottom: 0.5em;\n        margin-top: 0;\n    }\n\n    .implement-section .to-do .col-sm-2 input {\n        width: 100%;\n    }\n\n    .implement-section .col-sm-12.to-do>div:last-child.col-sm-3 .report-input {\n        width: calc(100% - 56px);\n        display: inline-block;\n    }\n\n    .implement-section .col-sm-12.to-do>div:last-child.col-sm-3 input {\n        width: 100%;\n        margin-bottom: 0.5em;\n    }\n\n    .implement-section .col-sm-12.to-do>div:last-child.col-sm-3 .fa {\n        display: inline-block;\n        width: auto;\n        margin-left: 8px;\n        border: none;\n    }\n\n    .implement-inner {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    .implement-inner .col-sm-5,\n    .implement-inner .col-sm-3 {\n        padding: 0;\n    }\n\n    .implement-inner .col-sm-3 {\n        border-left: 1px dotted $color-neutral-mid;\n    }\n\n    .implement-table {\n        border: 1px solid $color-neutral-mid;\n        margin-bottom: 15px;\n        width: 100%;\n        border-collapse: collapse;\n        text-align: left;\n    }\n\n    .ngx-datepicker-calendar-container {\n        z-index: 999;\n    }\n\n    .implement-table .heading-section {\n        display: block;\n        background-color: $integrator-color;\n        min-height: 30px;\n        padding: 0 10px;\n        color: $body-content-color;\n    }\n\n    .implement-table .heading-section--editbg {\n        background-color: #F5F5F5;\n        color: #676A6C;\n    }\n\n    .implement-table td,\n    .implement-table th {\n        padding: 0 !important;\n    }\n\n    .implement-table thead tr th,\n    .implement-table tbody tr td {\n        width: 15%;\n        padding: 0 !important;\n    }\n\n    .implement-table tbody tr td {\n        vertical-align: top;\n    }\n\n    .implement-table thead tr th:first-child,\n    .implement-table tbody tr td:first-child {\n        width: 40% !important;\n    }\n\n    .implement-table thead tr th:last-child,\n    .implement-table tbody tr td:last-child {\n        width: 30% !important;\n    }\n\n    .implement-table thead th:not(:last-child),\n    .implement-table tbody td:not(:last-child) {\n        border-right: 1px dotted $color-neutral-mid;\n    }\n\n    .implement-table tbody tr td input {\n        width: 100%;\n    }\n\n    .implement-table tbody tr td:first-child input {\n        width: calc(100% - 35px);\n    }\n\n    .implement-table tbody tr td:last-child input {\n        width: calc(100% - 59px);\n        margin-right: 10px;\n    }\n\n    .implement-table th:not(:first-child) {\n        text-align: left;\n    }\n\n    .implement-table th h4 {\n        color: #656565;\n    }\n\n    app-implement-challenge-action-plan,\n    app-implement-challenge-next24 {\n        display: block;\n        margin-top: 30px;\n    }\n\n    .card-default {\n        .card-body {\n            padding-top: 0;\n            padding-bottom: 0;\n        }\n\n        .list-columns {\n            padding-top: 10px !important;\n            padding-bottom: 10px !important;\n        }\n\n        .input-form {\n            label {\n                min-width: 20px !important;\n                margin-top: 10px;\n            }\n        }\n    }\n\n    .card-show .input-form {\n        padding-top: 15px;\n        padding-bottom: 10px;\n    }\n\n    ::ng-deep .card-default .alert {\n        margin-bottom: 0 !important;\n    }\n\n    .card-default .table.implement-table .list-columns {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n    }\n\n    .card-default .table.implement-table th h4,\n    .card-default .table.implement-table td p,\n    .card-default .table.implement-table td span {\n        margin-bottom: 0 !important;\n        padding: 12px !important;\n    }\n\n    .implement-table__head td {\n        background: $integrator-color;\n    }\n\n    .implement-table__head--editbg td {\n        background: #F5F5F5;\n        color: #676A6C;\n    }\n\n    .tooltipicon {\n        position: relative;\n        display: inline-block;\n        font-size: 18px;\n    }\n\n    .tooltipicon .tooltiptext {\n        visibility: hidden;\n        width: 250px;\n        background-color: #fff;\n        color: $implement-color;\n        text-align: center;\n        border-radius: 6px;\n        padding: 10px;\n        box-shadow: 0 0 18px rgba(0, 0, 0, .1);\n        font-family: 'Open Sans', sans-serif;\n        font-size: 15px;\n        line-height: 1.2em;\n        /* Position the tooltip */\n        position: absolute;\n        top: 15px;\n        right: 10px;\n        z-index: 1;\n\n        @media screen and (max-width: 1199px) {\n            left: auto;\n            right: 10px;\n        }\n    }\n\n    .tooltipicon:hover .tooltiptext {\n        visibility: visible;\n    }\n\n    .btn-develop {\n        background-color: #66bd4a;\n        color: #fff;\n        padding: 0.375rem 1rem;\n        border-radius: 3px;\n    }\n\n    table.implement-table td>div,\n    table.implement-table td>form {\n        padding: 10px !important;\n    }\n\n    .report-grid {\n        input {\n            display: inline-block;\n        }\n    }\n\n    .btn-bottom .btn-warning {\n        margin-left: 10px;\n    }\n\n    .generate-pdf {\n        cursor: pointer;\n        position: absolute;\n        top: 10px;\n        right: 10px;\n\n        @media screen and (max-width: 851px) {\n            position: relative;\n            top: 0;\n            right: 0;\n            margin-bottom: 20px;\n        }\n    }\n\n    .summary-pdf {\n        cursor: pointer;\n        position: absolute;\n        top: 10px;\n        right: 170px;\n\n        @media screen and (max-width: 851px) {\n            position: relative;\n            top: 0;\n            right: -7px;\n            margin-bottom: 20px;\n        }\n    }\n\n\n    .mainnav {\n        @include fflex();\n        @include fflex-jcc();\n        margin: 30px 0 40px;\n\n        @media #{$mq-sm} {\n            margin: 10px 0 30px;\n        }\n\n        &.mainnav--bottom {\n            margin: 30px 0 40px;\n\n            ul {\n                li {\n                    a {\n                        padding: 12px 30px;\n                        font-family: 'Open Sans', sans-serif;\n                        font-weight: 700;\n                        font-size: 16px;\n\n                        @media only screen and (max-width: 991px) {\n                            padding: 10px 20px;\n                            font-size: 14px;\n                        }\n\n                        @media only screen and (max-width: 767px) {\n                            padding: 9px;\n                            font-size: 11px;\n                        }\n                    }\n\n                    &.active {\n                        a {\n                            background-color: #bbb !important;\n                            border-top: 1px solid #bbb !important;\n                            border-right: 1px solid #bbb !important;\n                            border-bottom: 1px solid #bbb !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        &--editmode {\n            margin: 0 0 15px;\n\n            .mainnav__list {\n                flex: 1;\n                border-radius: 5px;\n\n                @media #{$mq-sm} {\n                    flex: none;\n                    width: 100%;\n                }\n\n                li {\n                    width: 100%;\n                    flex: 1;\n\n                    a {\n                        width: 100%;\n                        padding: 5px 2px;\n                        text-align: center;\n                    }\n                }\n            }\n        }\n\n        &__editmodeicon {\n            margin-left: 5px;\n\n            @media #{$mq-sm} {\n                margin: 10px 0 0 auto;\n            }\n\n            ul {\n                display: flex;\n                flex-wrap: wrap;\n                margin: 0;\n                padding: 0;\n                height: 100%;\n\n                li {\n                    list-style: none;\n                    transition: none;\n                    width: 37px;\n                    height: 100%;\n                    border-radius: 5px;\n                    background-color: #fff;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    cursor: pointer;\n                    border: 1px solid $cn-border-color;\n\n\n                    &.active {\n                        background-color: #676a6c;\n                    }\n\n                    &:not(:last-child) {\n                        margin-right: 5px;\n\n                        @media #{$mq-md} {\n                            margin-right: 0;\n                        }\n                    }\n\n                    @media #{$mq-md} {\n                        width: 35px;\n                        height: 31px;\n                        display: none;\n                    }\n\n                    &.mainnav__editmodepin {\n                        display: flex;\n\n                        svg {\n                            .st0 {\n                                fill: #FFFFFF;\n                            }\n\n                            .st1 {\n                                fill: #cfdbe2;\n                            }\n                        }\n\n                        &--pinactive {\n                            svg {\n                                .st0 {\n                                    fill: #6d6e71;\n                                }\n\n                                .st1 {\n                                    fill: #FFFFFF;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n    }\n\n    .stick-challenge {\n        position: relative;\n\n        .card__implementtable {\n            min-height: auto;\n            overflow-y: auto;\n            overflow-x: hidden;\n            z-index: 9;\n            position: relative;\n\n            .card-body__subtitle {\n                position: sticky;\n                top: 0;\n                z-index: 99;\n                background-color: #fff;\n            }\n        }\n\n    }\n\n    .info {\n        color: #fff;\n        border: 1px solid $implement-color;\n        margin-bottom: 18px;\n        padding: 20px 40px;\n        border-radius: 6px;\n\n        @media #{$mq-md} {\n            padding: 12px 20px;\n        }\n\n        &.infotitle {\n            background-color: $implement-color;\n\n            h3 {\n                color: #fff\n            }\n        }\n\n        h1 {\n            font-size: 36px;\n            font-weight: 500;\n            margin: 0;\n            @include headingfont();\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n\n            @media #{$mq-md} {\n                font-size: 28px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 24px;\n            }\n\n            .info__maintitle {\n                margin-right: auto;\n\n            }\n\n            small {\n                color: #fff;\n                font-size: 80%;\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 5px;\n                }\n            }\n        }\n\n        .card__toprow {\n            @include fflex();\n            @include fflex-aic();\n            margin: 0 -15px;\n\n            &--tne {\n\n                .card__topcol {\n\n                    &:first-child {\n                        width: 72% !important;\n\n                        @media #{$mq-sm} {\n                            flex: 1;\n                            width: auto !important;\n                        }\n                    }\n                }\n            }\n\n            .card__topcol {\n                padding: 0 15px;\n                width: calc(100% / 3);\n\n                &:nth-child(1) {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        flex: 1;\n                        margin-right: auto;\n                    }\n                }\n\n                &--tab {\n                    width: 44%;\n\n                    @media #{$mq-sm} {\n                        width: 120px;\n                    }\n                }\n\n                &--tt {\n                    width: 28%;\n                    margin-left: auto;\n                    text-align: right;\n\n                    @media #{$mq-sm} {\n                        width: auto;\n                    }\n\n                    svg {\n                        max-width: 16px;\n                        cursor: pointer;\n                    }\n\n                    .card__pinicon {\n                        position: absolute;\n                        right: -17px;\n                        top: -15px;\n                        width: 20px;\n\n                        @media #{$mq-md} {\n                            right: 2px;\n                            top: 1px;\n                        }\n                    }\n                }\n\n                &.card__topcol--title {\n                    @include fflex();\n                    @include fflex-aic();\n\n                    &>div:first-child {\n                        margin-right: 15px;\n                    }\n                }\n\n                &.card__topcol--tab {\n                    @include fflex();\n                    @include fflex-jcc();\n\n                    ul {\n                        @include fflex();\n                        margin: 0;\n                        padding: 0;\n                        border-radius: 3px;\n                        line-height: 1;\n\n                        li {\n                            &:first-child {\n                                button {\n                                    svg {\n                                        right: calc(100% + 1px)\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            left: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:last-child {\n                                button {\n                                    svg {\n                                        left: calc(100% + 1px);\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            right: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:not(:first-child) {\n                                margin-left: -1px;\n                            }\n\n                            &:only-child {\n                                button {\n                                    border-radius: 3px;\n                                }\n                            }\n\n                            &.card__topactive {\n                                button {\n                                    color: $implement-color;\n                                    border: 1px solid $implement-color;\n\n                                    span.card__topcount {\n                                        color: $implement-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &.card__topcomplete {\n                                button {\n                                    opacity: 0.2;\n                                    border: 1px solid $implement-color;\n                                    color: $implement-color;\n\n                                    span.card__topcount {\n                                        color: $implement-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            button {\n                                position: relative;\n                                color: $develop-color;\n                                font-size: 17px;\n                                padding: 6px 16px;\n                                @include headingfont();\n                                display: inline-block;\n                                height: 100%;\n                                border: 0;\n                                background-color: transparent;\n                                @include transition-slow();\n                                -webkit-appearance: none;\n                                -moz-appearance: none;\n                                appearance: none;\n\n                                svg {\n                                    position: absolute;\n                                    top: -1px;\n                                    height: calc(100% + 2px);\n\n                                    .st0 {\n                                        fill: $implement-color;\n                                    }\n                                }\n\n                                @media #{$mq-md} {\n                                    padding: 4px 6px;\n                                    font-size: 13px;\n                                }\n\n                                &:focus {\n                                    outline: none;\n                                    box-shadow: none;\n                                }\n\n                                &>.card__topdesktext {\n                                    @media only screen and (max-width: 1180px) {\n                                        display: none;\n                                    }\n                                }\n\n                                &>.card__topmobiletext {\n                                    display: none;\n\n                                    @media only screen and (max-width: 1180px) {\n                                        display: inline-block;\n                                    }\n                                }\n\n                                &>span.card__topcount {\n                                    width: 16px;\n                                    height: 16px;\n                                    line-height: 16px;\n                                    display: inline-block;\n                                    text-align: center;\n                                    font-size: 0.5em;\n                                    background-color: $implement-color;\n                                    color: #fff;\n                                    margin-left: 4px;\n                                    border-radius: 50%;\n                                    vertical-align: bottom;\n                                    position: relative;\n                                    top: -1px;\n\n                                    @media only screen and (max-width: 630px) {\n                                        position: absolute;\n                                        top: auto;\n                                        bottom: -2px;\n                                        right: 0;\n                                        margin: 0;\n                                    }\n                                }\n\n                                &:hover {\n                                    color: $implement-color;\n                                    opacity: 1;\n                                }\n\n                                &:hover>span.card__topcount {\n                                    color: $implement-color;\n                                    background-color: #efefef;\n                                    opacity: 1;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            .card__h3button {\n                border: 1px solid $implement-color;\n                background-color: transparent;\n                padding: 4px 26px;\n                border-radius: 3px;\n                @include headingfont();\n                color: $implement-color;\n                font-size: 22px;\n                line-height: 1.2;\n                @include transition-slow();\n                cursor: pointer;\n\n                &:hover {\n                    background-color: $implement-color;\n                    color: #fff;\n                }\n\n                &:focus {\n                    outline: none;\n                }\n            }\n\n            .tooltipicon {\n                cursor: pointer;\n                position: relative;\n                font-size: 18px;\n                display: inline-block;\n\n                i {\n                    color: $implement-color;\n                }\n\n                &:hover>i>.tooltiptext {\n                    visibility: visible;\n                }\n\n                .tooltiptext {\n                    visibility: hidden;\n                    width: 250px;\n                    background-color: #fff;\n                    color: $implement-color;\n                    text-align: center;\n                    border-radius: 6px;\n                    padding: 10px;\n                    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                    font-size: 13px;\n                    font-family: 'Open Sans', sans-serif;\n                    line-height: 1.5;\n                    position: absolute;\n                    top: 15px;\n                    right: 10px;\n                    z-index: 1;\n                }\n            }\n        }\n\n        h3 {\n            font-size: 20px;\n            margin: 0;\n            cursor: pointer;\n            color: $implement-color;\n            @include headingfont();\n            @include fflex();\n            @include fflex-aic();\n\n            @media #{$mq-md} {\n                font-size: 16px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 15px;\n                word-break: break-word;\n            }\n\n            &>*:not(:last-child) {\n                margin-right: 5px;\n            }\n\n            .card__bwnh3pencil {\n\n                a {\n                    color: $implement-color;\n                }\n            }\n\n            .card__bwnh3button {\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 10px;\n                }\n\n                button {\n                    font-size: 18px !important;\n                    padding-right: 15px !important;\n                    padding-left: 15px !important;\n\n                    @media #{$mq-sm} {\n                        font-size: 16px !important;\n                    }\n                }\n            }\n\n            i {\n                cursor: pointer;\n                font-size: 0.9em;\n\n                &+div {\n                    padding-left: 7px;\n\n                    span {\n                        display: block;\n                        font-size: 0.7em;\n                    }\n                }\n\n                &+span {\n                    padding-left: 7px;\n                }\n            }\n\n            a {\n                margin-left: 10px;\n                color: $implement-color;\n            }\n\n            &.d-flex {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n\n                div:first-child {\n                    padding-right: 10px;\n                }\n\n                div:nth-child(2) {\n                    span {\n                        display: block;\n                    }\n                }\n            }\n        }\n\n        .tooltipicon {\n            position: relative;\n            display: inline-block;\n\n            &:hover>i>.tooltiptext {\n                visibility: visible;\n            }\n\n            .tooltiptext {\n                visibility: hidden;\n                width: 250px;\n                background-color: #fff;\n                color: $implement-color;\n                text-align: center;\n                border-radius: 6px;\n                padding: 10px;\n                box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                font-size: 15px;\n                line-height: 1.2em;\n                position: absolute;\n                top: 15px;\n                right: 10px;\n                z-index: 1;\n            }\n        }\n    }\n\n    .topheading {\n        color: #fff;\n        background-color: $implement-color;\n        border-color: $implement-color;\n        margin-bottom: 18px;\n        padding: 24px;\n        border-radius: 6px;\n\n        h1 {\n            font-size: 36px;\n            font-weight: 500;\n            margin: 0;\n\n            small {\n                color: #fff;\n                font-size: 80%;\n            }\n        }\n    }\n\n    .card-default {\n        &.card-default--summary {\n            box-shadow: none;\n\n            .info {\n                border-top: 0;\n                border-right: 0;\n                border-left: 0;\n                padding-right: 20px;\n                padding-left: 20px;\n            }\n\n            .card-body {\n                border-right: 0;\n                border-bottom: 0;\n                border-left: 0;\n                border-radius: 0;\n\n                &__inner {\n                    padding: 15px 20px;\n                }\n            }\n\n            &+div {\n                margin-top: 20px;\n            }\n        }\n\n        &+div {\n            margin-top: 30px;\n        }\n\n        .info {\n            margin: 0;\n\n            &.card__headactive {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n\n                &--cc {\n                    background-color: $implement-color;\n\n                    .card__topcol {\n                        h3 {\n                            color: #fff;\n                        }\n\n                        ul {\n                            li {\n\n                                button {\n                                    border-color: #fff;\n                                    background-color: #fff;\n\n                                    span {\n                                        color: $implement-color;\n                                        background-color: #fff;\n                                    }\n\n                                    .st0 {\n                                        fill: #fff !important;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    i {\n                        color: #fff;\n                    }\n                }\n\n                .card__topcol--tt {\n                    svg {\n                        max-width: 16px;\n                        width: 100%;\n                    }\n\n                    .tooltipicon {\n                        i {\n                            color: #ff485c;\n                        }\n                    }\n                }\n\n                &.challenge__sol {\n                    display: flex;\n                    flex-wrap: wrap;\n                    justify-content: space-between;\n                    position: relative;\n\n                    .card__topcol--tt {\n                        span {\n                            position: absolute;\n                            right: 8px;\n                            top: 6px;\n                        }\n                    }\n                }\n            }\n        }\n\n        border-radius: 6px;\n        border-top-width: 3px;\n        border: 0;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n\n        .card-body__inner {\n            padding: 15px 40px;\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n\n        }\n\n        .card-body {\n            display: none;\n            border: 1px solid $cn-border-color;\n            border-top: 0;\n            border-radius: 0 0 6px 6px;\n            overflow: hidden;\n\n            &--ov {\n                overflow: visible;\n            }\n\n            &.card-show {\n                display: block;\n\n                &__wbg {\n                    background-color: #fff;\n                }\n\n            }\n\n            &__finalstate {\n                p {\n                    font-size: 15px;\n                    font-weight: 600;\n\n                    @media #{$mq-sm} {\n                        font-size: 13px;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &--2 {\n                    @include fflex();\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n\n                        p {\n                            position: relative;\n                            padding-left: 10px;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 8px;\n                                left: 0;\n                                width: 5px;\n                                height: 5px;\n                                border-radius: 50%;\n                                background-color: #444;\n                            }\n                        }\n                    }\n                }\n            }\n\n            &__subtitle {\n                margin-bottom: 16px;\n                padding-left: 0;\n\n                &--pl0 {\n                    padding-left: 0;\n                }\n\n                *:last-child {\n                    margin-bottom: 0;\n                }\n\n                p {\n                    color: #969798;\n                    font-size: 15px;\n\n                    i {\n                        padding-left: 5px;\n                    }\n                }\n            }\n\n            &__pdfdropdown {\n                padding: 0;\n                margin: 0;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                &>li {\n                    list-style: none;\n                    position: relative;\n\n                    &+li {\n                        margin-left: 15px;\n                    }\n\n                    &>a {\n                        font-size: 16px;\n                        color: #676a6a;\n                        font-weight: 700;\n                        background-color: #fff;\n                        border: 1px solid #ededed;\n                        border-radius: 6px;\n                        overflow: hidden;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        -ms-flex-wrap: wrap;\n                        flex-wrap: wrap;\n                        -webkit-transition: all ease 0.3s;\n                        -o-transition: all ease 0.3s;\n                        transition: all ease 0.3s;\n\n                        @media #{$mq-sm} {\n                            font-size: 13px;\n                        }\n\n                        .page-heading__icon {\n                            padding: 11px 14px;\n                            border-right: 1px solid #ededed;\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            align-items: center;\n                        }\n\n                        .page-heading__text {\n                            padding: 11px 14px;\n                        }\n\n                        &:hover {\n                            border: 1px solid $cn-border-color;\n                        }\n                    }\n\n                    &:hover>ul {\n                        display: block;\n                    }\n\n                    ul {\n                        margin: 0;\n                        padding: 0;\n                        display: none;\n                        position: absolute;\n                        top: calc(100%);\n                        right: 0;\n                        width: 144px;\n                        border: 1px solid #dcdcdc;\n                        border-radius: 3px;\n                        background-color: #fff;\n                        z-index: 99;\n\n                        li {\n                            list-style: none;\n\n                            &+li {\n                                border-top: 1px solid #dcdcdc;\n                            }\n\n                            a {\n                                color: #696969;\n                                text-align: center;\n                                padding: 8px 20px;\n                                font-size: 13px;\n                                display: block;\n                                -webkit-transition: all ease 0.3s;\n                                -o-transition: all ease 0.3s;\n                                transition: all ease 0.3s;\n\n                                &:hover {\n                                    background-color: #f9f9f9;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .c-radio {\n            label {\n                padding-left: 0;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 2px;\n                    margin-right: 6px;\n                    opacity: 0.6;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                margin: 0;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 50%;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        position: absolute;\n                        color: $implement-color;\n                        opacity: 0;\n                        font-size: 11px;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $implement-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .checkbox {\n            margin-top: 0;\n\n            label {\n                min-height: 20px;\n                padding-left: 0;\n                margin-bottom: 0;\n                font-weight: 400;\n                cursor: pointer;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 1px;\n                    margin-right: 6px;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        font-size: 12px;\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: #5D9CEC;\n                        background-color: #5D9CEC;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .card-body__button {\n            background-color: #f5f5f5;\n            border-top: 1px solid #e3e3e3;\n            padding: 12px 40px;\n\n            .card-button {\n                margin: 0;\n                @include fflex();\n                @include fflex-aic();\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    text-align: center;\n                    @include transition-slow();\n\n                    &+.btn {\n                        margin-left: 15px;\n                    }\n\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n                }\n\n                .float-right {\n                    margin-left: auto;\n                }\n\n                .btn-implement {\n                    background-color: $implement-color;\n                    border-color: $implement-color;\n                    color: #fff;\n\n                    &:hover {\n                        background-color: $implement-color;\n                        border-color: $implement-color;\n                    }\n                }\n\n                .btn-danger {\n                    background-color: #fff;\n                    border-color: #fff;\n                    color: #ef6272;\n\n                    &:hover {\n                        background-color: #ED2D2D;\n                        border-color: #EC2121;\n                    }\n                }\n\n                .btn-warning {\n                    em {\n                        margin: 0;\n                    }\n                }\n\n                .btn-deleteall {\n                    border: 0;\n                    background-color: transparent;\n                    position: relative;\n                    overflow: hidden;\n                    box-shadow: none;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n\n                    span {\n                        position: absolute;\n                        left: 110%;\n                        @include transition-slow();\n                    }\n\n                    &:hover {\n                        background-color: #fff;\n                        color: #ed5562;\n                        padding-right: 16px;\n                        padding-left: 16px;\n\n                        &>span {\n                            position: relative;\n                            left: 0;\n                        }\n\n                        em {\n                            margin-right: 6px;\n                        }\n                    }\n\n                    em {\n                        font-size: 1em;\n                        margin-right: 0;\n                        @include transition-slow();\n                    }\n                }\n            }\n        }\n\n        .card-body--ebtn {\n            margin-top: 15px;\n            padding: 15px 40px;\n            border-top: 1px solid $cn-border-color;\n\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n\n            .card-body--ebtnrow {\n                margin: 0 -8px;\n                @include fflex();\n                @include fflex-aic();\n\n                &>div {\n                    padding: 0 8px;\n\n                    @media #{$mq-sm} {\n                        width: 100%;\n                        text-align: center;\n\n                        &+div {\n                            margin-top: 10px;\n                        }\n                    }\n\n                    &.card-body--col {\n                        &--last {\n                            margin-left: auto;\n                        }\n                    }\n                }\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    padding: 7px 16px;\n                    text-align: center;\n                    transition: all ease 0.3s;\n                    font-weight: 900;\n\n                    @media #{$mq-md} {\n                        font-size: 12px;\n                    }\n\n                    i,\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n\n                    &--save {\n                        background-color: $develop-color;\n                        color: #fff;\n                    }\n\n                    &--clarify {\n                        background-color: $clarify-color;\n                        color: #fff;\n                    }\n\n                    &--implement {\n                        background-color: $implement-color;\n                        color: #fff;\n                        border-color: $implement-color;\n                        font-weight: 900;\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                    }\n\n                    &--cancel {\n                        padding: 0;\n                        background-color: transparent;\n                        margin-left: 0;\n                        border: 0;\n                        font-family: $font-stack;\n                        font-size: 14px;\n                        font-weight: 700;\n                        color: $body-content-color;\n\n                        &:hover {\n                            color: #000;\n                        }\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                    }\n\n                    &--converge {\n                        padding: 0 8px;\n                    }\n\n                    &--deleteall {\n                        border: 0;\n                        background-color: transparent;\n                        position: relative;\n                        overflow: hidden;\n                        box-shadow: none;\n                        padding-right: 0;\n                        padding-left: 0;\n                        @include transition-slow();\n\n                        i {\n                            font-size: 14px;\n                            color: $body-content-color;\n                        }\n\n                        span {\n                            position: absolute;\n                            left: 110%;\n                            @include transition-slow();\n                        }\n\n                        &:hover {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px !important;\n                            }\n                        }\n\n                        em {\n                            font-size: 1em;\n                            margin-right: 0;\n                            @include transition-slow();\n                        }\n                    }\n                }\n            }\n        }\n\n\n        .note-3 {\n            padding: 15px 15px 10px;\n            border: 2px solid $clarify-color;\n            margin-bottom: 15px;\n\n            label {\n                color: $clarify-color;\n            }\n        }\n\n        .footer-line {\n            color: $clarify-color;\n        }\n\n        p {\n            font-size: 15px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        .card-body__edit {\n            position: relative;\n            overflow: hidden;\n\n            &--ov {\n                overflow: visible;\n            }\n\n            .breakthrough-input-tabs,\n            .datadump-input-tabs {\n                width: 100%;\n                margin-right: 0;\n                position: relative;\n\n                input,\n                select {\n                    height: 45px;\n                    padding: 5px 15px;\n                    border: 1px solid $color-neutral-mid !important;\n                    border-radius: 4px;\n                    font-size: 15px;\n\n                    &:focus {\n                        outline: none !important;\n                    }\n                }\n            }\n\n            .card-body__editrow {\n                margin: 0 -15px;\n                @include fflex();\n\n                &>div {\n                    padding: 0 15px;\n                    width: 100%;\n                    margin-bottom: 15px;\n\n                    &.card-body__editcol--mb0 {\n                        margin-bottom: 0;\n                    }\n\n                    &.card-body__editcol--2 {\n                        width: calc(100% / 2);\n                    }\n\n                    &>div {\n                        position: relative;\n                    }\n                }\n\n                select {\n                    -webkit-appearance: none;\n                    -moz-appearance: none;\n                    appearance: none;\n                    background-image: url($assets+'/images/select.png');\n                    background-size: 10px;\n                    background-position: right 10px center;\n                    background-repeat: no-repeat;\n                }\n\n                textarea {\n                    width: 100%;\n                    border: 1px solid $color-neutral-mid;\n                    resize: none;\n                    border-radius: 3px;\n                    padding: 10px 15px;\n                    font-size: 15px;\n                }\n\n                .breakthrough-input-tabs,\n                .breakthrough-input-tabs {\n                    @include fflex();\n\n                    &>.card-body__editlabel {\n                        width: 35px;\n                        padding-right: 15px;\n                        @include fflex();\n                        @include fflex-aic();\n                    }\n\n                    &>.card-body__editnumber {\n                        width: 40px;\n                        text-align: center;\n                        @include fflex();\n                        @include fflex-aic();\n                        @include fflex-jcc;\n                        border-right: 0;\n                        border-radius: 4px 0 0 4px;\n\n                        &+.card-body__editinput {\n                            width: calc(100% - 41px);\n                        }\n\n                        label {\n                            margin-bottom: 0;\n                            font-weight: 900;\n                        }\n                    }\n\n                    &>.card-body__editselect {\n                        width: 315px;\n                        padding-right: 15px;\n                    }\n\n                    &>.card-body__editinput {\n                        width: calc(100% - 351px);\n\n                        input.add-line {\n                            // width: 100%;\n                            padding-right: 70px;\n                        }\n\n                        &.card-body__editinput--np {\n                            input {\n                                padding-right: 15px;\n                            }\n                        }\n                    }\n\n                    &>.card-body__editinput:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n\n            &+.card-body__addnew {\n\n                button {\n                    font-size: 14px;\n                    font-weight: bold;\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n\n                    &:hover {\n                        background-color: $implement-color;\n                        border: 1px solid $implement-color;\n                        color: #fff;\n                        padding-right: 12px;\n                        padding-left: 12px;\n                    }\n                }\n            }\n        }\n\n        .breakthrough-input-tabs {\n            width: 90%;\n            display: inline-block;\n            margin-right: 20px;\n\n            input {\n                height: 35px;\n                padding: 10px 15px;\n                border: 1px solid $implement-color;\n                border-radius: 4px;\n                margin-bottom: 0;\n            }\n        }\n\n        .input-tabs {\n            &+i {\n                position: relative;\n                top: -1px;\n            }\n\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            @include fflex-aic();\n            width: calc(100%);\n            padding: 0 0 0 0;\n            margin: 0;\n\n\n            &.card__body--cs {\n                position: relative;\n                border-bottom: 1px solid #e4e4e4;\n\n                &::before,\n                &::after {\n                    content: \"\";\n                    position: absolute;\n                    bottom: -1px;\n                    right: calc(100%);\n                    width: 40px;\n                    height: 1px;\n                    background-color: #e4e4e4;\n                }\n\n                &::after {\n                    right: auto;\n                    left: calc(100%);\n                }\n            }\n\n            .select_faded {\n                opacity: 0.2;\n                padding-left: 32px;\n            }\n\n            input,\n            select {\n                height: 45px;\n                padding: 5px 15px;\n                border: 1px solid #e3e3e3;\n                border-radius: 4px;\n                margin: 7px 0px;\n            }\n\n            label {\n                width: 20px;\n                margin: 0;\n            }\n\n            select {\n                width: 9%;\n            }\n\n            input {\n                width: 90%;\n                margin-left: 15px;\n            }\n        }\n\n        .input-group-text {\n            cursor: pointer;\n            padding: 3px 16px;\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 1.528571429;\n            color: #495057;\n            text-align: center;\n            white-space: nowrap;\n            background-color: #E9ECEF;\n            border: 1px solid #DDE6E9;\n            border-radius: 0.25rem;\n            position: absolute;\n            top: calc(50%);\n            right: 5px;\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n            @include transition-slow();\n\n            &:hover {\n                background-color: $implement-color;\n                border-color: $implement-color;\n                color: #fff;\n            }\n\n            i {\n                font-size: 12px;\n            }\n        }\n\n        .list-columns {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n            counter-reset: section;\n\n            &.list-columns--2 {\n                &>div {\n                    width: 100%;\n                }\n            }\n\n            .brainstorm-tabs {\n                position: relative;\n                padding-left: 23px;\n\n                &::before {\n                    counter-increment: section;\n                    content: counter(section) \".\";\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                }\n            }\n        }\n    }\n\n    .idea-shop-list {\n        padding: 20px;\n        margin-left: 17px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        li {\n            width: calc(100% / 2);\n            margin-bottom: 10px;\n        }\n    }\n\n    .brainstorm__col {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        margin-bottom: 17px;\n\n        .brainstorm-main {\n            width: calc(100% - 68px);\n            display: inline-block;\n            margin-right: 20px;\n\n            .brainstorm-group {\n                width: 100%;\n                position: relative;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                .input-group-prepend {\n                    margin-right: -1px;\n                    width: 45px;\n\n                    .input-group-text {\n                        background: transparent;\n                        border-color: $implement-color;\n                        height: 35px;\n                        padding: 0;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        align-items: center;\n                        -webkit-box-pack: center;\n                        -ms-flex-pack: center;\n                        justify-content: center;\n                    }\n                }\n\n                input {\n                    width: calc(100% - 45px);\n                    height: 35px;\n                    border: 1px solid $ideate-color;\n                    border-radius: 0 0.25rem 0.25rem 0;\n                }\n            }\n        }\n    }\n\n    .point-evaluation {\n        padding: 0px;\n        border: 1.5px solid #66bd4a;\n        margin-bottom: 20px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        &>div {\n            padding: 10px;\n        }\n\n        .pluses {\n            border-right: 1.5px solid #66bd4a;\n            border-bottom: 1.5px solid #66bd4a;\n\n            h4::before {\n                content: \"P\";\n            }\n        }\n\n        .opportunities {\n            border-bottom: 1.5px solid #66bd4a;\n\n            h4::before {\n                content: \"O\";\n            }\n        }\n\n        .issues {\n            border-right: 1.5px solid #66bd4a;\n\n            h4::before {\n                content: \"I\";\n            }\n        }\n\n        .new-thinking {\n            h4::before {\n                content: \"Nt\";\n            }\n        }\n\n        h4 {\n            position: relative;\n            padding-left: 50px;\n            color: #66bd4a;\n            font-size: 16px;\n            margin: 0 0 10px;\n\n            &::before {\n                content: \"\";\n                background: #66bd4a;\n                color: #fff;\n                font-size: 20px;\n                height: 35px;\n                width: 35px;\n                position: absolute;\n                border-radius: 50%;\n                top: 0;\n                left: 0;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-pack: center;\n                -ms-flex-pack: center;\n                justify-content: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n            }\n\n            small {\n                display: block;\n                margin-top: 4px;\n                color: inherit;\n                line-height: 1.3;\n                font-size: 82%;\n            }\n        }\n\n        p {\n            color: #66bd4a;\n        }\n\n        span.fill-bottom {\n            width: 100%;\n        }\n\n        .icons-right {\n            i {\n                font-size: 21px;\n                color: #66bd4a;\n                cursor: pointer;\n\n                &:not(:last-child) {\n                    margin-right: 10px;\n                }\n            }\n        }\n\n        .fill-input {\n            width: calc(100% - 35px);\n            display: inline-block;\n            margin-right: 15px;\n\n            label {\n                display: inline-block;\n                min-width: 20px;\n                color: #66bd4a;\n            }\n\n            input {\n                display: inline-block;\n                width: calc(100% - 20px);\n                height: 34px;\n                border-radius: 3px;\n                margin: 1px 0;\n            }\n        }\n\n        .input-tabs {\n            .input-tabs__row {\n                width: calc(100% - 35px);\n                display: inline-block;\n                margin-right: 15px;\n                position: relative;\n                vertical-align: middle;\n\n                .pr-0 {\n                    padding-right: 0;\n                }\n\n                &>i {\n                    position: absolute;\n                    top: 50%;\n                    right: -26px;\n                    -webkit-transform: translateY(-50%);\n                    -ms-transform: translateY(-50%);\n                    transform: translateY(-50%);\n                }\n            }\n\n            label {\n                display: inline-block;\n                min-width: 20px;\n                color: #66bd4a;\n            }\n\n            input,\n            select {\n                height: 34px;\n                border-radius: 3px;\n                margin: 1px 0;\n            }\n\n            select {\n                display: inline-block;\n                width: calc(100% - 20px);\n            }\n        }\n    }\n\n    .develop-footer-note {\n        color: #66bd4a;\n    }\n\n    .d-flex.count-div {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n\n        label {\n            width: 35px;\n        }\n    }\n\n    .implement-section .input-tabs {\n        display: block !important;\n    }\n\n    .card-bottom-button {\n        .button {\n            font-size: 13px;\n            color: #fff;\n            padding: 8px 10px;\n            border-radius: 3px;\n            -webkit-transition: all ease 0.3s;\n            -o-transition: all ease 0.3s;\n            transition: all ease 0.3s;\n\n            &:hover {\n                opacity: .8;\n            }\n\n            i {\n                font-size: 0.8em;\n            }\n\n            &.btn-clarify {\n                background-color: $clarify-color;\n            }\n\n            &.btn-ideate {\n                background-color: $ideate-color;\n            }\n\n            &.btn-implement {\n                background-color: $implement-color;\n            }\n        }\n    }\n\n    .cancelTool.tooltipicon {\n        position: relative;\n        display: inline-block;\n        cursor: pointer;\n\n        .tooltiptext {\n            width: 150px;\n            color: #676a6c;\n            text-align: center;\n            font-size: 13px;\n            font-family: 'Open Sans', sans-serif;\n            line-height: 1.5;\n            padding: 6px;\n            top: -25px;\n            left: 10px;\n        }\n\n        &:hover {\n            .tooltiptext {\n                visibility: visible;\n            }\n        }\n    }\n\n    .card_solution {\n        b {\n            font-size: 15px;\n        }\n\n        .solution-list {\n            margin-bottom: 0;\n            width: 100%;\n            margin-top: 10px;\n\n            span {\n                display: block;\n            }\n\n            &__selection1 {\n                margin-top: 10px;\n            }\n\n            &__selection2 {\n                margin-left: 20px;\n            }\n        }\n    }\n}\n\n::ng-deep.cdk-overlay-container {\n    position: absolute !important;\n    top: 288px !important;\n}\n\n.tooltippopup {\n    max-width: 360px;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    position: fixed;\n    top: 0;\n    right: -400px;\n    padding: 45px 24px 24px;\n    text-align: left;\n    z-index: 9999;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n    @include transition-slow();\n    overflow-y: auto;\n\n    &--active {\n        right: 0;\n    }\n\n    &__btn {\n        @include fflex();\n        padding: 0;\n        margin: 0 0 10px;\n\n        li {\n            list-style: none;\n            text-align: center;\n            cursor: pointer;\n            width: calc(100% / 3);\n\n            button {\n                width: 100%;\n                color: $implement-color;\n                font-size: 12px;\n                padding: 6px 16px;\n                @include headingfont();\n                display: inline-block;\n                height: 100%;\n                border: 0;\n                border: 1px solid $implement-color;\n                background-color: transparent;\n                transition: all ease 0.3s;\n                @include appearance-none();\n\n                &:focus {\n                    outline: none;\n                }\n\n                &.tooltippopup__btncompleted {\n                    opacity: 0.2;\n\n                    &:hover {\n                        opacity: 1;\n                    }\n                }\n\n                &.tooltippopup__btnactive {\n                    opacity: 1;\n                }\n\n                &:hover {\n                    position: relative;\n                    z-index: 9;\n                }\n            }\n\n            &+li {\n                margin-left: -1px;\n            }\n\n            &:first-child {\n                button {\n                    border-radius: 3px 0 0 3px\n                }\n            }\n\n            &:last-child {\n                button {\n                    border-radius: 0 3px 3px 0;\n                }\n            }\n        }\n    }\n\n    h4 {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 16px;\n        line-height: 1.2;\n    }\n\n    p {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 14px;\n        line-height: 1.4;\n    }\n\n    &__close {\n        position: absolute;\n        top: 10px;\n        right: 25px;\n        width: 18px;\n        height: 18px;\n        cursor: pointer;\n        @include transition-slow();\n\n        &:hover {\n            -webkit-transform: rotate(360deg);\n            -ms-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n\n        &>div {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n\n            span {\n                position: absolute;\n                background: #676a6c;\n\n                &:nth-child(1) {\n                    top: 0;\n                    left: calc(50% - 1px);\n                    width: 2px;\n                    height: 100%;\n                }\n\n                &:nth-child(2) {\n                    top: calc(50% - 1px);\n                    left: 0;\n                    width: 100%;\n                    height: 2px;\n                }\n            }\n        }\n    }\n\n    &__child {\n        margin-top: 20px;\n\n        &data {\n            .table-responsive {\n                overflow-x: auto;\n                margin-bottom: 10px;\n\n                table {\n                    min-width: 297px;\n                    border: 1px solid #e7eaec;\n\n                    th,\n                    td {\n                        border: 1px solid #e7eaec;\n                        min-width: 120px;\n                    }\n                }\n\n                &+* {\n                    margin-top: 20px;\n                }\n            }\n\n            &--clarify {\n                h4 {\n                    color: $clarify-color;\n                }\n            }\n\n            &--ideate {\n                h4 {\n                    color: $ideate-color;\n                }\n            }\n\n            &--develop {\n                h4 {\n                    color: $develop-color;\n                }\n            }\n\n            &--implement {\n                h4 {\n                    color: $implement-color;\n                }\n            }\n\n            h4 {\n                font-size: 16px;\n                font-weight: 500;\n                margin: 0 0 2px;\n                @include headingfont();\n\n                &+h5 {\n                    mask-type: 10px;\n                }\n            }\n\n            p {\n                margin-bottom: 5px;\n                line-height: 1.3;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            &+div {\n                margin-top: 17px;\n            }\n        }\n    }\n\n    &__links {\n        padding: 0;\n        margin: 0;\n\n        li {\n            list-style: none;\n            width: 100%;\n\n            a {\n                position: relative;\n                color: $implement-color;\n                @include transition-slow();\n\n                &::before {}\n\n                &:hover {\n                    opacity: 0.75;\n                }\n            }\n\n            &+li {\n                margin-top: 4px;\n\n            }\n        }\n    }\n}\n\n\n\n.popaccordian {\n    &__row {\n        &head {\n            position: relative;\n            cursor: pointer;\n            border: 1px solid $implement-color;\n            padding: 9px;\n            border-radius: 3px;\n            @include fflex();\n\n            &arrow {\n                position: absolute;\n                top: 0;\n                left: 0;\n            }\n\n            h5 {\n                margin: 0;\n                position: relative;\n                color: $implement-color;\n                padding-left: 10px;\n                @include headingfont();\n\n                i {\n                    @include transition-slow();\n                }\n            }\n        }\n\n        &body {\n            border: 1px solid $implement-color;\n            border-top: 0;\n            display: none;\n            border-radius: 0 0 3px 3px;\n\n            &inner {\n                padding: 10px;\n\n                &>*:last-child {\n                    margin-bottom: 0;\n                }\n\n                h5 {\n                    margin: 0 0 10px;\n                    position: relative;\n                    color: $implement-color;\n                    @include headingfont();\n                }\n\n                ul {\n                    margin: 0;\n                    padding: 0;\n\n                    li {\n                        list-style: none;\n                        font-size: 14px;\n                        line-height: 1.3;\n                        position: relative;\n                        padding-left: 10px;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 7px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n\n                        &+li {\n                            margin-top: 5px;\n                        }\n                    }\n                }\n            }\n\n        }\n\n        &+div {\n            margin-top: 15px;\n        }\n\n        &--active {\n            .popaccordian__rowhead {\n                border-radius: 3px 3px 0 0;\n\n                i {\n                    @include transRotate (90deg);\n                }\n            }\n        }\n\n        &:first-child {\n            .popaccordian__rowbody {\n                display: block;\n            }\n        }\n\n    }\n\n}\n\n\n.prevnext {\n    padding: 10px 0;\n\n    &__inner {\n        @include fflex();\n        @include fflex-aic();\n        padding: 0;\n        margin: 0;\n    }\n\n    li {\n        list-style: none;\n\n        &.prevnext__next {\n            margin-left: auto;\n        }\n\n        &.prevnext__action {\n            margin-left: auto;\n\n            a {\n                @include headingfont();\n                font-size: 14px;\n                color: #676a6c;\n                cursor: pointer;\n                opacity: 0.6;\n                @include transition-slow();\n\n                &:hover {\n                    opacity: 1;\n                }\n            }\n        }\n\n        &.prevnext__prev a {\n            &:hover>i {\n                left: -5px;\n            }\n        }\n\n        &.prevnext__next a {\n            background-color: $implement-color;\n            color: #fff;\n            opacity: 1;\n            padding: 6px 12px;\n            border-radius: 3px;\n\n            &:hover>i {\n                left: 3px;\n            }\n        }\n\n        a {\n            @include headingfont();\n            font-size: 14px;\n            color: #676a6c;\n            opacity: 0.47;\n            padding: 6px 0;\n            display: inline-block;\n            @include transition-slow();\n\n            i {\n                position: relative;\n                font-size: 1.1em;\n                left: 0;\n                @include transition-slow();\n            }\n        }\n    }\n}\n\n\n::ng-deep.card__implementtable {\n    overflow-y: auto;\n\n    table {\n\n        @media #{$mq-sm} {\n            width: 700px;\n            max-width: none;\n        }\n    }\n\n    .card-body__addnew {\n        button {\n            font-size: 14px;\n            font-weight: bold;\n            background-color: transparent;\n            border: 1px solid transparent;\n            padding-right: 0;\n            padding-left: 0;\n            margin: 6px 50px;\n            color: $body-content-color;\n            @include transition-slow();\n\n            &:hover {\n                background-color: $implement-color;\n                border: 1px solid $implement-color;\n                color: #fff;\n                padding-right: 12px;\n                padding-left: 12px;\n            }\n        }\n    }\n}\n\n\n.playbtn {\n    position: absolute;\n    right: 9px;\n    bottom: 7px;\n    color: #06a6ce;\n}\n\n.Del-data-btn {\n    padding: 40px 0;\n\n    .btn {\n        margin-left: 15px;\n        // border-color: #007bff;\n        background-color: #fff;\n        border-color: #f5f5f5;\n        color: #ff485c;\n    }\n\n    .cancelbtn {\n        color: #676a6c;\n        text-align: center;\n        font-size: 15px;\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.5;\n        padding: 6px;\n    }\n}\n\n\n\n.editmode {\n    margin-bottom: 30px;\n\n    &--not {\n        margin-bottom: 0;\n    }\n\n\n    &__list {\n\n        &row {\n            display: grid;\n            grid-template-columns: repeat(2, 1fr);\n            grid-gap: 15px;\n\n            @media #{$mq-sm} {\n                grid-template-columns: 1fr;\n            }\n\n            &--equalblocks {\n                display: flex;\n                flex-wrap: wrap;\n\n                &>.editmode__listcol {\n                    flex: 1;\n\n                    @media #{$mq-sm} {\n                        flex: none;\n                        width: 100%;\n                    }\n                }\n\n            }\n\n            &--fullblocks {\n                grid-template-columns: 1fr;\n            }\n\n            &--grid {\n                &1 {\n                    grid-template-columns: 1fr;\n                }\n\n                &3 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 3;\n                    }\n                }\n\n                &4 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 4;\n                    }\n                }\n\n                &5 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 5;\n                    }\n                }\n\n                &6 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 6;\n                    }\n                }\n\n                &7 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 7;\n                    }\n                }\n            }\n        }\n\n        &cell {\n            padding: 10px 15px;\n            background-color: #EBEBEB;\n            border: 1px solid $cn-border-color;\n            border-radius: 6px;\n            height: 100%;\n\n\n            @media #{$mq-sm} {\n                font-size: 13px;\n            }\n\n            h3 {\n                color: #676A6C;\n                margin-bottom: 5px;\n\n                a,\n                i {\n                    color: inherit;\n                }\n            }\n\n            p {\n                font-size: 15px;\n                font-weight: 600;\n\n                @media #{$mq-sm} {\n                    font-size: 13px;\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n\n}\n\n.trackInfo {\n    padding: 2px 16px;\n    background-color: #6d6e71;\n    color: #fff;\n    margin-left: 40px;\n    border-radius: 5px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    font-size: 10px;\n}\n\n\n.row {\n    &--editmodebg {\n        background-color: #fff;\n        padding: 40px 35px;\n    }\n\n    &--wbg {\n        background-color: #fff;\n    }\n}\n\n.loader-container {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    top: 0;\n    bottom: 0;\n    background: rgba(236, 236, 236, .9);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: none;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    z-index: 9999999999;\n    height: 100vh;\n    margin: 0 auto;\n}\n\n.row--editmodebg {\n    background-color: #fff;\n    padding: 40px 35px;\n}\n\n.trackInfo {\n    padding: 2px 16px;\n    background-color: #6d6e71;\n    color: #fff;\n    margin-left: 40px;\n    border-radius: 5px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    font-size: 10px;\n\n    &--inputclr {\n        color: $implement-color;\n        font-size: 11px;\n        background: transparent;\n        margin-left: 8px;\n        padding-left: 0;\n    }\n}\n\n.loader-spin {\n    background-color: hsla(0, 0%, 92.5%, .9);\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.loader__inner {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n    animation: blink 2s linear infinite;\n    opacity: 0;\n}\n\n#Path_130 {\n    animation: blink 2s linear infinite;\n    animation-delay: .5s;\n    opacity: 0;\n}\n\n#Path_132 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1s;\n    opacity: 0;\n}\n\n#Path_131 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1.5s;\n    opacity: 0;\n}\n\n@keyframes blink {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n\n}\n\n::ng-deep .datepicker-container {\n\n    input {\n        padding: 8px 10px;\n        font-size: 14px;\n        width: 200px;\n        outline: 0;\n        border: 1px solid #dfe3e9;\n    }\n}\n\n.card-body__minus {\n\n    &--hide {\n        display: none;\n    }\n}\n\n.pdf-modal {\n    display: none;\n}","// Shared Challenge Navigator mixins, breakpoints, and variables\n// Import this at the top of each stage component SCSS\n\n@import './../../../assets/styles/variables';\n\n// CN-specific variables\n$cn-border-color: #CFDBE2;\n$cn-edit-bg: #ebebeb;\n$cn-card-bg: #f5f5f5;\n\n// Breakpoints\n$mq-pc: 'only screen and (max-width: 1200px)';\n$mq-md: 'only screen and (max-width: 991px)';\n$mq-sm: 'only screen and (max-width: 767px)';\n$mq-mobile: 'only screen and (max-width: 480px)';\n\n// Mixins\n@mixin fflex() {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n@mixin fflex-jcc() {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@mixin fflex-aic() {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n@mixin transition-slow() {\n    -webkit-transition: all ease 0.3s;\n    -o-transition: all ease 0.3s;\n    transition: all ease 0.3s;\n}\n\n@mixin transition-none() {\n    -webkit-transition: none;\n    -o-transition: none;\n    transition: none;\n}\n\n@mixin appearance-none() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@mixin transRotate($rotate) {\n    -webkit-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    transform: rotate($rotate);\n}\n\n@mixin headingfont() {\n    font-family: $muso-700 !important;\n    font-weight: normal !important;\n}\n\n@mixin contentfont() {\n    font-family: $muso-300 !important;\n    font-weight: normal !important;\n}\n\n// Common element resets\nlabel {\n    font-family: 'Open Sans', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
